<template>
    <div class="menu-bar">
        <div class="icons-main">
            <div class="icon-visibility-container">
                <div class="icon icon-main-md" @click="openAbout()"></div>
            </div>
        </div>

        <div v-show="loggedIn && licenseValid" class="icons-nav collapseable">
            <buttonc v-for="(icon, i) in iconsNav" type="menu" :key="i" :icon="icon.icon" :label="$t(icon.labelKey)" :link="icon.link" :active="isActive(icon.link)" :disabled="!allowContentSwitch"
                 @click="ToggleDropDown($event, icon.items, 0, 10); $forceUpdate();"/>
            <buttonc class="collapsed" type="menu" icon="fa-caret-square-down" :label="$t('global.ui.menu')" @click="ToggleDropDown($event, iconsNav, 0, 10)" :disabled="!allowContentSwitch"/>
        </div>
        <div class="icons-left" v-show="loggedIn && allowContentSwitch" >
            <!-- <div class="dividerh"></div> -->
            <buttonc class="store-settings" type="menu" icon="fa-cog" v-bind:style="{color: isActive({name: 'storemain'})? 'var(--md)' : 'var(--contrast-4)'}" v-tooltip="() => $t('global.menubar.settings')"
                @click="RouterTo({name: 'storemain', params: {storeId: store.state.storeId, tab: 'storestructure'}})" />
            <dropdownsearch :state="storeSelectorState" style="width: 245px"/>
            <buttonc class="store-settings" style="float: right; color: var(--contrast-4);"
                     v-if="isSuperUser || (userInfo != null && userInfo.id == '263a698f-d25e-4fd2-a81c-b85b4c213952')"
                     type="menu"
                     :icon="!hideDisabledStores ? 'fa-eye' : 'fa-eye-slash'"
                     :v-tooltip="!hideDisabledStores ? 'Inaktive Stores einblenden' : 'Inaktive Stores ausblenden'"
                     @click="hideDisabledStores = !hideDisabledStores"/>
        </div>
        <div v-if="loggedIn || loggedInNoStores" class="login">
            <locale-switcher v-if="loggedIn"></locale-switcher>
            <buttonc class="nightmode-toggle" type="icon-overlay" v-if="!loggedInNoStores && isSuperUser" :icon="anonMode ? 'fas fa-user-secret' : 'far fa-user-secret'" role="button" @click="toggleAnonMode()"></buttonc>

            <buttonc class="nightmode-toggle" type="icon-overlay" v-if="!loggedInNoStores" icon="fa-lightbulb" role="button" @click="toggleDarkMode()"></buttonc>
            <!--<buttonc class="calendar" type="icon-overlay" v-if="!loggedInNoStores && allowContentSwitch" icon="fa-calendar-alt"
            v-bind:style="{color: isActive({name: 'calendar'})? 'var(--md)' : 'var(--contrast-4)'}" role="button" @click="RouterTo({name: 'calendar', params: {storeId: store.state.storeId}})"></buttonc> -->
            <div class="menu" v-on:click="showNotificationsPopup">
                <buttonc type="icon-overlay" v-if="!loggedInNoStores" icon="fa-bell"></buttonc>
                <div v-if="eventNumber > 0" class="notification" v-bind:class="{big: eventNumber > 99}">{{ eventNumber > 99 ? '99+' : eventNumber }}</div>
            </div>
            <div class="dividerh"></div>
            <!-- <i class="fas fa-users" v-tooltip="OnlineUserState">
                <div v-if="activeStoreUsers.length > 0" class="notification" v-bind:class="{big: activeStoreUsers.length > 99}">{{ activeStoreUsers.length }}</div>
            </i>
            <div class="dividerh"></div> -->
            <div class="menu" v-on:click="OpenUserMenu($event)">
                <employeepicture :pictureUrl="my_image"/>
            </div>
        </div>

        <dropdownlogin ref="dropdownlogin"/>
        <dropdown ref="dropdown" v-for="(dropdown, i) in dropdowns" :dropdown="dropdown" :key="i"/>


        <iframe id="authframe" style="display: none;" src="https://account.meindienstplan.at/lsproxy.html" width="10" height="10">
            <!-- Auth IFrame -->
        </iframe>
        <accountPreferences ref="accountPreferences"/>

        <div class="discarder" v-if="modalStartup || modalNopermissions || modalNolicense || modalUnapprovedPrefs ||
                modalDeclinedShifts || modalExpiringContracts || missingDocEmployees || modalDocwarnings ||
                modalMissingDataUnderaged || modalMissingParttimeAvailabilityEmployees"
             @click="modalStartup = false; modalNopermissions = false; modalNolicense = false; modalUnapprovedPrefs = false;
                modalDeclinedShifts = false; modalExpiringContracts = false; missingDocEmployees = false; modalDocwarnings = false;
                modalMissingDataUnderaged = false; modalMissingParttimeAvailabilityEmployees = false;">
        </div>
        <div class="md-card dialog" v-if="modalStartup">
            <h6 class="md-card-header" style="text-align: left">
                {{ $t('global.menubar.messages.browserNoticeHeader') }}
                <i class="fas fa-times" style="float: right"
                   @click="modalStartup = false"></i>
            </h6>
            <div class="md-card-body">
                <div class="md-card-select">
                    <span v-html="$t('global.menubar.messages.browserNoticeBody')"></span>
                </div>
            </div>
            <div class="right mright35">
                <buttonc type="no-border green" :label="$t('global.menubar.messages.understand')"
                         @click="modalStartup = false" />
            </div>
        </div>
        <div class="md-card dialog" v-if="modalNopermissions">
            <h6 class="md-card-header" style="text-align: left">
                {{ $t('global.menubar.messages.noPermissionHeader') }}
                <i class="fas fa-times" style="float: right"
                   @click="modalNopermissions = false"></i>
            </h6>
            <div class="md-card-body">
                <div class="md-card-select">
                    <span v-html="$t('global.menubar.messages.invalidRoleBody')"></span>
                </div>
            </div>
            <div class="right mright35">
                <buttonc type="no-border green" :label="$t('global.menubar.messages.understand')"
                         @click="modalNopermissions = false" />
            </div>
        </div>
        <div class="md-card dialog" v-if="modalNolicense">
            <h6 class="md-card-header" style="text-align: left">
                {{ $t('global.menubar.messages.licenseExpHeader') }}
                <i class="fas fa-times" style="float: right"
                   @click="modalNolicense = false"></i>
            </h6>
            <div class="md-card-body">
                <div class="md-card-select">
                    <span v-html="$t('global.menubar.messages.licenseExpBody')"></span>
                </div>
            </div>
            <div class="right mright35">
                <buttonc type="no-border green" :label="$t('global.menubar.messages.understand')"
                         @click="modalNolicense = false" />
            </div>
        </div>
        <div class="md-card xl" v-if="modalUnapprovedPrefs">
            <h6 class="md-card-header" style="text-align: left">
                {{ $t('global.menubar.messages.unapprovedAbsencesHeader') }}
                <i class="fas fa-times" style="float: right"
                   @click="modalUnapprovedPrefs = false"></i>
            </h6>
            <div class="md-card-body">
                <div class="md-card-select">
                    <labelc type="header" class="full" :text="$t('global.menubar.messages.unapprovedAbsencesBody')" />
                    <datatablesimple style="width: 100%" :state="unapprovedAbsencesState" />
                </div>
            </div>
            <div class="right mright35">
                <buttonc type="no-border green" :label="$t('global.ui.close')"
                         @click="modalUnapprovedPrefs = false" />
            </div>
        </div>
        <div class="md-card xl" v-if="modalDeclinedShifts">
            <h6 class="md-card-header" style="text-align: left">
                {{ $t('global.menubar.messages.declinedShiftsHeader') }}
                <i class="fas fa-times" style="float: right"
                   @click="modalDeclinedShifts = false"></i>
            </h6>
            <div class="md-card-body">
                <div class="md-card-select">
                    <labelc type="header" class="full" :text="$t('global.menubar.messages.declinedShiftsBody')" />
                    <datatablesimple style="width: 100%" :state="declinedShiftsState" />
                </div>
            </div>
            <div class="right mright35">
                <buttonc type="no-border green" :label="$t('global.ui.close')"
                         @click="modalDeclinedShifts = false" />
            </div>
        </div>
        <div class="md-card" v-if="modalExpiringContracts">
            <h6 class="md-card-header" style="text-align: left">
                {{ $t('global.menubar.messages.expiringContractsHeader') }}
                <i class="fas fa-times" style="float: right"
                   @click="modalExpiringContracts = false"></i>
            </h6>
            <div class="md-card-body">
                <div class="md-card-select">
                    <labelc type="header" class="full" :text="$t('global.menubar.messages.expiringContractsBody')" />
                    <table style="width: 100%;">
                        <tr>
                            <th class="w33 dp-bold">{{ $tc('global.general.employee') }}</th>
                            <th class="w33 dp-bold">{{ $t('global.general.contractEnd') }}</th>
                            <th class="w33 dp-bold">{{ $t('global.general.contractEndReason') }}</th>
                        </tr>
                        <tr v-for="c in expiringContracts" v-bind:key="c.id" class="my-1" style="text-align: left;">
                            <td>
                                <small>{{ employees[c.employeeId] != undefined ? (employees[c.employeeId].lastName + ' ' + employees[c.employeeId].firstName) : '' }}</small>
                            </td>
                            <td><small>{{ $helpers.extractDateStringTZ(c.to, 'DD.MM.YYYY', true) }}</small></td>
                            <td><small>{{
                                    c.exitReason && exitReasonsMap[c.exitReason]
                                        ? $i18n.locale === 'de'
                                            ? exitReasonsMap[c.exitReason].label_de
                                            : exitReasonsMap[c.exitReason].label
                                        : $t('global.general.notStated')
                                }}</small></td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="right mright35">
                <buttonc type="no-border green" :label="$t('global.ui.close')"
                         @click="modalExpiringContracts = false" />
            </div>
        </div>
        <div class="md-card" v-if="missingDocEmployees">
            <h6 class="md-card-header" style="text-align: left">
                {{missingDocModalTitle}}
                <i class="fas fa-times" style="float: right"
                   @click="missingDocEmployees = false"></i>
            </h6>
            <div class="md-card-body">
                <div class="md-card-select">
                    <labelc type="header" class="full" :text="missingDocModalDescription"/>
                    <div v-for="employeeId in missingDocumentModalEmployees" v-bind:key="employeeId" class="name-field">
                        {{
                            employees[employeeId] != undefined ? (employees[employeeId].lastName + ' ' +
                                employees[employeeId].firstName) : '' }}
                    </div>
                </div>
            </div>
            <div class="right mright35">
                <buttonc type="no-border green" :label="$t('global.ui.close')" @click="missingDocEmployees = false"/>
            </div>
        </div>
        <div class="md-card" v-if="modalDocwarnings">
            <h6 class="md-card-header" style="text-align: left">
                {{ $t('global.menubar.messages.documentNoteHeader') }}
                <i class="fas fa-times" style="float: right"
                   @click="modalDocwarnings = false"></i>
            </h6>
            <div class="md-card-body">
                <div class="md-card-select"
                     v-if="unconfirmedDocuments.length > 0 && notificationBellConfigState.showUnconfirmedDocuments">
                    <labelc type="header" class="full" style="{font-size: 16px; font-family: DistrictProBold,serif;
                                color: var(--col-warning);}"
                            :text="$t('global.menubar.messages.documentNoteAreUnconfirmedBody')" />
                    <table style="width: 100%;">
                        <tr>
                            <th class="w25 dp-bold warn">{{ $tc('global.general.employee') }}</th>
                            <th class="w25 dp-bold warn">{{ $tc('global.general.document') }}</th>
                            <th class="w25 dp-bold warn">{{ $tc('global.general.type') }}</th>
                            <th class="w25 dp-bold warn">{{ $t('global.general.creationDate') }}</th>
                        </tr>
                        <tr v-for="file in unconfirmedDocuments" v-bind:key="file.id" class="my-1"
                            style="text-align: left;">
                            <td><small class="warn">{{ employees[file.employeeId] != undefined ?
                                (employees[file.employeeId].lastName + ' ' + employees[file.employeeId].firstName) : ''
                                }}</small>
                            </td>
                            <td><small class="warn">{{ file.name }}</small></td>
                            <td><small class="warn">{{ $helpers.documentTypeLabel(file.documentType) }}</small>
                            </td>
                            <td><small class="warn">{{ $helpers.extractDateStringTZ(file.creationDate, 'DD.MM.YYYY')
                                }}</small>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="md-card-select"
                     v-if="expiredDocuments.length > 0 && notificationBellConfigState.showExpiredDocuments">
                    <labelc type="header" class="full" style="{font-size: 16px; font-family: DistrictProBold,serif;
                                color: var(--col-error);}"
                            :text="$t('global.menubar.messages.documentNoteAreExpiredBody')" />
                    <table style="width: 100%;">
                        <tr>
                            <th class="w25 dp-bold error"> {{ $tc('global.general.employee') }}</th>
                            <th class="w25 dp-bold error"> {{ $tc('global.general.document') }}</th>
                            <th class="w25 dp-bold error"> {{ $tc('global.general.type') }}</th>
                            <th class="w25 dp-bold error"> {{ $t('global.general.expiringDate') }}</th>
                        </tr>
                        <tr v-for="file in expiredDocuments" v-bind:key="file.id" class="my-1"
                            style="text-align: left;">
                            <td><small class="error">{{ employees[file.employeeId] != undefined ?
                                (employees[file.employeeId].lastName + ' ' + employees[file.employeeId].firstName) : ''
                                }}</small>
                            </td>
                            <td><small class="error">{{ file.name }}</small></td>
                            <td><small class="error">{{ $helpers.documentTypeLabel(file.documentType)
                                }}</small>
                            </td>
                            <td><small class="error">{{ $helpers.extractDateStringTZ(file.validUntil, 'DD.MM.YYYY')
                                }}</small>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="md-card-select"
                     v-if="expiringSoonDocuments.length > 0 && notificationBellConfigState.showExpiringDocuments">
                    <labelc type="header" class="full" style="{font-size: 16px; font-family: DistrictProBold,serif;
                                color: var(--col-warning);}"
                            :text="$t('global.menubar.messages.documentNoteWillExpireBody')" />
                    <table style="width: 100%;">
                        <tr>
                            <th class="w25 dp-bold">{{ $tc('global.general.employee') }}</th>
                            <th class="w25 dp-bold">{{ $tc('global.general.document') }}</th>
                            <th class="w25 dp-bold">{{ $tc('global.general.type') }}</th>
                            <th class="w25 dp-bold">{{ $t('global.general.expiringDate') }}</th>
                        </tr>
                        <tr v-for="file in expiringSoonDocuments" v-bind:key="file.id" class="my-1"
                            style="text-align: left;">
                            <td>
                                <small>{{ employees[file.employeeId] != undefined ? (employees[file.employeeId].lastName + ' ' + employees[file.employeeId].firstName) : ''
                                    }}</small>
                            </td>
                            <td><small>{{ file.name }}</small></td>
                            <td><small>{{ $helpers.documentTypeLabel(file.documentType) }}</small></td>
                            <td><small>{{ $helpers.extractDateStringTZ(file.validUntil, 'DD.MM.YYYY') }}</small>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="right mright35">
                <buttonc type="no-border green" :label="$t('global.ui.close')" @click="modalDocwarnings = false"/>
            </div>
        </div>
        <div class="md-card" v-if="modalMissingDataUnderaged">
            <h6 class="md-card-header" style="text-align: left">
                {{ $tc('menu.missing.dataForUnderage') }}
                <i class="fas fa-times" style="float: right"
                   @click="modalMissingDataUnderaged = false"></i>
            </h6>
            <div class="md-card-body">
                <div class="md-card-select">
                    <table style="width: 100%;" v-if="missingDataForUnderagedEmployees.length > 0">
                        <tr>
                            <th class="w25 dp-bold">{{ $tc('global.general.employee') }}</th>
                            <th class="w25 dp-bold" colspan="3">{{ $t('pages.employeeCoreData.emergencyContact') }}
                            </th>
                        </tr>
                        <tr>
                            <th class="w25 dp-bold">{{ $t('pages.employeeData.name') }}</th>
                            <th class="w25 dp-bold">{{ $t('pages.employeeData.name') }}</th>
                            <th class="w25 dp-bold">Adresse</th>
                            <th class="w25 dp-bold">{{ $t('pages.employeeCoreData.homephone') }}</th>
                        </tr>
                        <tr v-for="emp in missingDataForUnderagedEmployees" v-bind:key="emp.id" style="text-align: left;">
                            <td><small style="">{{ emp.lastName + ' ' + emp.firstName }}</small></td>
                            <td><small
                                :style=getTextColor(emp.guardianName)>{{ emp.guardianName != null && emp.guardianName !== '' ? emp.guardianName : $t('global.ui.unavailable')
                                }}</small>
                            </td>
                            <td><small
                                :style=getTextColor(emp.guardianAddress)>{{ emp.guardianAddress != null && emp.guardianAddress !== '' ? emp.guardianAddress : $t('global.ui.unavailable')
                                }}</small>
                            </td>
                            <td><small
                                :style=getTextColor(emp.guardianPhone)>{{ emp.guardianPhone != null && emp.guardianPhone !== '' ? emp.guardianPhone : $t('global.ui.unavailable')
                                }}</small>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="right mright35">
                <buttonc type="no-border green" :label="$t('global.ui.close')" @click="modalMissingDataUnderaged = false"/>
            </div>
        </div>
        <div class="md-card" v-if="modalMissingParttimeAvailabilityEmployees">
            <h6 class="md-card-header" style="text-align: left">
                {{ $t('global.menubar.messages.missingAvailabilitiesHeader') }}
                <i class="fas fa-times" style="float: right"
                   @click="modalMissingParttimeAvailabilityEmployees = false"></i>
            </h6>
            <div class="md-card-body">
                <div class="md-card-select">
                    <labelc type="header" class="full"
                            :text="$t('global.menubar.messages.missingAvailabilitiesBody')" />
                    <table style="width: 100%;">
                        <tr v-for="emp in missingAvailabilityEmployees" v-bind:key="emp.id" style="text-align: left;">
                            <td><small>{{ (emp.lastName + ' ' + emp.firstName) }}</small></td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="right mright35">
                <buttonc type="no-border green" :label="$t('global.ui.close')" @click="modalMissingParttimeAvailabilityEmployees = false"/>
            </div>
        </div>
    </div>
</template>

<script>

import dropdown from './uicomponents/dropdown.vue'
import dropdownlogin from './uicomponents/dropdownlogin.vue'
import dropdownsearch from './uicomponents/dropdownsearch.vue'
import accountPreferences from './AccountPreferences.vue'
import VueEventBus from '../vue-event-bus';
import { mapGetters } from 'vuex';
import Vue from 'vue';
import VueMatomo from 'vue-matomo';
import localeSwitcher from './menucontext/locale-switcher';

export default {
        name: 'MenuBar',
        components: {
            dropdown,
            dropdownlogin,
            dropdownsearch,
            accountPreferences,
            localeSwitcher,
        },
        data() {
            return {
                warningShown: false,
                loggedInNoStores: false,
                licenseValid: false,
                authValidity: 86400, // 24 hours
                localStorageSupported: false,
                my_image: 'https://fileserver1.meindienstplan.de/api/file?id=d55fd03c-9999-4a48-8515-906585d0bc0e&accessToken=ALPW6DGLB92U2U0S',
                fixedMainIcon: true,

                dropdowns: [],
                processedStores: [],
                toggled: false,
                iconsMainCollapsed: false,
                authFrame: null,
                iconsNav: [
                    {labelKey: 'global.menubar.roster', icon: 'fa-calendar-check', link: {name: 'planning', params: {storeId: this.$store.state.storeId, tab: 'roster'}}},
                    {labelKey: 'global.menubar.planning', icon: 'fa-chart-line', link: {name: 'planningindicatormain', params: {storeId: this.$store.state.storeId, tab: 'planningindicatoroverview'}}},
                    {labelKey: 'global.menubar.preferences', icon: 'fa-umbrella-beach', link: {name: 'preferences', params: {storeId: this.$store.state.storeId, tab: 'preferenceview'}}},
                    {labelKey: 'global.menubar.employees', icon: 'fa-users', link: {name: 'employees', params: {storeId: this.$store.state.storeId, tab: 'employeedata'}}},
                    {labelKey: 'global.menubar.workbalance', icon: 'fa-clipboard', link: {name: 'workbalances', params: {storeId: this.$store.state.storeId, tab: 'employeepayrollaccounting'}}},
                    {labelKey: 'global.menubar.reports', icon: 'fa-file-signature', link: {name: 'reports', params: {storeId: this.$store.state.storeId, tab: 'reportworktimeoverview'}}},
                    /* {label: 'Kalender', icon: 'fa-calendar', link: {name: 'calendar', params: {storeId: this.$store.state.storeId}}},
                    {label: 'Betriebseinstellung', icon: 'fa-building', link: {name: 'storemain', params: {storeId: this.$store.state.storeId}}}, */
                ],
                iconsNavCollapsed: [
                    {labelKey: 'global.menubar.roster', icon: 'fa-calendar-check', link: {name: 'planning', params: {storeId: this.$store.state.storeId, tab: 'roster'}}},
                    {labelKey: 'global.menubar.planning', icon: 'fa-chart-line', link: {name: 'planningindicatormain', params: {storeId: this.$store.state.storeId, tab: 'planningindicatormain'}}},
                    {labelKey: 'global.menubar.preferences', icon: 'fa-umbrella-beach', link: {name: 'preferences', params: {storeId: this.$store.state.storeId, tab: 'preferenceview'}}},
                    {labelKey: 'global.menubar.employees', icon: 'fa-users', link: {name: 'employees', params: {storeId: this.$store.state.storeId, tab: 'employeedata'}}},
                    {labelKey: 'global.menubar.workbalance', icon: 'fa-clipboard', link: {name: 'workbalances', params: {storeId: this.$store.state.storeId, tab: 'employeepayrollaccounting'}}},
                    {labelKey: 'global.menubar.reports', icon: 'fa-file-signature', link: {name: 'reports', params: {storeId: this.$store.state.storeId, tab: 'reportworktimeoverview'}}},
                    /* {label: 'Betriebseinstellung', icon: 'fa-building', link: 'storemain'}, */
                    {
                        labelKey: 'global.menubar.store', icon: 'fa-building', items: [
                        {label: this.$tc('global.menubar.store', 2), icon: 'fa-building'},
                    ]
                    }],
                user: {
                    items: [
                        {label: this.$t('global.menubar.myAccount'), externalLink: 'https://account.meindienstplan.at'}
                    ]
                },
                OnlineUserState: {
                    type: 'datafill',
                    header: 'Online:',
                    tooltip: true,
                    componentState: {
                        displayOnly: true,
                        entries: {}
                    }
                },
                store: this.$store,
                storeSettingsLoaded: false,
                employeeAvailabilityTypeMap: {},
                employeeAvailabilityStateMap: {},
                employees: {},
                activeEmployeesMap: {},
                employeeEmployeeFileMap: {},
                notificationLoadingState: 0,
                modalUnapprovedPrefs: false,
                unapprovedPreferences: [],
                modalExpiringContracts: false,
                expiringContracts: [],
                missingContractDocuments: [],
                exitReasonsMap: {},
                uiData: {},
                expiredDocuments: [],
                expiringSoonDocuments: [],
                unconfirmedDocuments: [],

                missingDocEmployees: false,
                missingDocModalTitle: '',
                missingDocModalDescription: '',
                missingDocumentModalEmployees: [],

                missingPassDocs: [],
                missingWorkPermitDocs: [],
                missingResidencePermitDocs: [],
                missingEducationPermitDocs: [],

                modalStartup: false,
                modalNopermissions: false,
                modalNolicense: false,
                modalDeclinedShifts: false,
                modalDocwarnings: false,
                modalMissingDataUnderaged: false,
                modalMissingParttimeAvailabilityEmployees: false,

                idPrevSortRadios: "unapproved-prefs-sort-radio-group",
                sortOptions: [
                    { text: this.$t('global.menubar.sortOptionCreationDate'), value: 0, size: "sm"},
                    { text: 'Datum der Abwesenheit', value: 1, size: "sm"},
                    { text: this.$tc('global.general.employee'), value: 2, size: "sm"},
                ],
                unapprovedPrefSortMode: 0,
                declinedShiftSortMode: 0,
                missingDataForUnderagedEmployees: {},
                missingAvailabilityEmployees: [],
                missingPersonnelIds: [],
                hideDisabledStores: true,
            }
        },
        computed: {
            ...mapGetters(['storeId', 'loggedIn', 'anonMode', 'userInfo', 'activeStoreUsersMap', 'allowContentSwitch', 'storeSettings', 'rosterFromTo', 'employeeMap', 'employeeAllUnapprovedPreferenceArray', 'employeeContractMap', 'employeeFilesMap', 'notificationBellConfigState', 'isSuperUser', 'shiftStatusLogMap', 'employeeAvailabilityMap']),
            eventNumber(){
                let num = 0;
                let config = this.notificationBellConfigState;
                let country = this.storeSettings != null ? this.storeSettings.country : 1;
                if(config.showExpiredDocuments) num += this.expiredDocuments.length;
                if(config.showExpiringDocuments) num += this.expiringSoonDocuments.length;
                if(config.showExpiringContracts) num += this.expiringContracts.length;
                if(config.showUnapprovedPreferences) num += this.unapprovedPreferences.length;
                if(config.showDeclinedShifts) num += this.declinedShifts.length;
                if(config.showMissingDataForUnderagedEmployees) num += this.missingDataForUnderagedEmployees.length;
                if(config.showMissingAvailabilityEmployees) num += this.missingAvailabilityEmployees.length;
                if(config.showMissingContractDocuments) num += this.missingContractDocuments.length;
                if(config.showUnconfirmedDocuments) num += this.unconfirmedDocuments.length;

                if(config.showMissingPassDocumentsForNonEU) num += this.missingPassDocs.length;
                if(config.showMissingWorkPermitDocumentsForNonEU) num += this.missingWorkPermitDocs.length;
                if(config.showMissingResidencePermitDocumentsForNonEU) num += this.missingResidencePermitDocs.length;
                if(config.showMissingEducationPermitDocumentsForNonEU && country == 2) num += this.missingEducationPermitDocs.length;
                if(config.showMissingPersonnelIds){ num += this.missingPersonnelIds.length; }

                return num;
            },
            hasSharepoint(){
                // TODO: has to be defined somewhere, e.g. sharepoint license in settings, free of charge for FN Köck
                return this.$store.state.storeId == 74 || this.$store.state.storeId == 76;
            },
            notificationDataReady(){
                return this.notificationLoadingState >= 4;
            },
            numCreationInfos(){
                let num = 0;
                this.unapprovedPreferences.forEach((pref)=>{
                    if(this.unapprovedPrefCreationInfo(pref).length > 0) num++;
                });
                return num;
            },
            activeStoreUsers(){
                return Object.values(this.activeStoreUsersMap).filter(entry => entry.id != this.userInfo.id);
            },
            loginUrl(){
                if(window.location.href.includes("web.meindienstplan.de")){
                    return "https://account.meindienstplan.at/#/?redirect=mdplde";
                }
                if(window.location.href.includes("localhost")){
                    return "https://account.meindienstplan.at/#/?redirect=localmdpl";
                }

                let sub = this.getSubDomain();
                if(sub === "staging") {
                    return "https://account.meindienstplan.at/#/?redirect=stagingmdpl";
                } else if(sub === "development") {
                    return "https://account.meindienstplan.at/#/?redirect=devmdpl";
                }
                return "https://account.meindienstplan.at/#/?redirect=mdpl";
            },
            computedIconsMain() {
                let sub = this.getSubDomain();
                let urls = []
                if(sub === "staging") {
                    urls =  ["https://account.meindienstplan.at/#/?redirect=stagingmzlogin", 'https://account.meindienstplan.at/#/?redirect=stagingmplogin', 'https://account.meindienstplan.at/#/?redirect="devml": ', 'https://account.meindienstplan.at/#/?redirect=stagingmdcorelogin'];
                } else if(sub === "development") {
                    urls =  ["https://account.meindienstplan.at/#/?redirect=stagingmzlogin", 'https://account.meindienstplan.at/#/?redirect=stagingmplogin', 'https://account.meindienstplan.at/#/?redirect="devml": ', 'https://account.meindienstplan.at/#/?redirect=stagingmdcorelogin'];
                } else {
                     urls =  ["https://account.meindienstplan.at/#/?redirect=mzlogin", 'https://account.meindienstplan.at/#/?redirect=mplogin', 'https://account.meindienstplan.at/#/?redirect=ml', 'https://account.meindienstplan.at/#/?redirect=mdcorelogin'];
                }

                let iconsMain = [
                    {icon: 'icon-main-mz', label: 'Meine Zeiterfassung', externalLink: urls[0]},
                    {icon: 'icon-main-mp', label: 'Mein Player', externalLink: urls[1]},
                    {icon: 'icon-main-ml', label: 'Meine Lohnabrechnung', externalLink: urls[2]},
                    {icon: 'fa-user', label: this.$t('global.menubar.myCustomerCenter'), externalLink: urls[3]}
                ];

                return iconsMain;

            },
            userFullname: function(){
                if(this.userInfo.firstname && this.userInfo.lastname){
                    return this.userInfo.firstname + ' ' + this.userInfo.lastname
                } else {
                    return 'User';
                }

            },
            storeSelectorState() {
                let view = this;
                const storeId = this.$store.state.storeId;
                const items = this.processedStores || [];
                const filteredItems = items
                        .filter((item) => !item.disabled || !this.hideDisabledStores || item.id === storeId)
                        .map((item) => ( { ...item, selected: item.id === storeId } ));
                const selectedItem = items.find(({id}) => id === storeId);

                let state = {
                    toggled: false,
                    displayedItems: [],
                    input: selectedItem ? selectedItem.label : '',
                    selectedItem: selectedItem,
                    items: filteredItems,
                    selectFirst: false,
                    noBorder: true,
                    onceSelected: ($event, item) => {
                        if(view.allowContentSwitch) {
                            const name = view.$route.name;
                            view.$store.commit('setStoreId', {storeId: item.id});
                            view.$store.commit('setStoreData', {storeData: item});
                            view.$store.commit('setCompanyId', {companyId: item.companyId});
                            view.$router.push({ name: name, params: { storeId: this.$store.state.storeId } });
                        }
                        /*requestAnimationFrame(function(){
                            requestAnimationFrame(function(){

                            })
                        }) */
                    },
                }
                return state;
            },
            declinedShifts() {
              let view = this;
              let declinedShifts = [];

              if (Object.values(view.shiftStatusLogMap).length > 0) {
                let shiftLogs = {};
                Object.values(view.shiftStatusLogMap).forEach(log => {
                  if (!shiftLogs.hasOwnProperty(log.shiftId)
                      || (log.createdAt > shiftLogs[log.shiftId].createdAt)) {
                    shiftLogs[log.shiftId] = log;
                  }
                });

                Object.values(shiftLogs).forEach(log => {
                  if (log.status >= 3) {
                    log.from = log.shiftFrom;
                    log.to = log.shiftTo;
                    declinedShifts.push(log);
                  }
                });
              }

              declinedShifts.sort((a,b) => {
                if (view.declinedShiftSortMode === 0 && view.employees[a.employeeId] !== undefined && view.employees[b.employeeId] !== undefined) {
                  if (view.employees[a.employeeId].lastName.localeCompare(view.employees[b.employeeId].lastName) !== 0) {
                    return view.employees[a.employeeId].lastName.localeCompare(view.employees[b.employeeId].lastName);
                  }
                  return view.employees[a.employeeId].firstName.localeCompare(view.employees[b.employeeId].firstName);
                } else if (view.declinedShiftSortMode === 1) {
                  let aFrom = this.$helpers.getMomentFromString(a.from)._d.getTime();
                  let bFrom = this.$helpers.getMomentFromString(b.from)._d.getTime();
                  if (aFrom > bFrom) return 1;
                  else if (bFrom > aFrom) return -1;
                  return 0;
                } else if (view.declinedShiftSortMode === 2) {
                  if (a.status > b.status) return 1;
                  else if (b.status > a.status) return -1;
                  return 0;
                }
                return 0;
              });

              return declinedShifts;
            },
            unapprovedAbsencesState() {
                let view = this;

                let state = {
                    headerMap: [],
                };

                let columns = {
                    employee: view.$tc('global.general.employee'),
                    absence: view.$tc('global.general.absence'),
                    month: view.$tc('global.general.month'),
                    from: view.$t('global.general.from'),
                    to: view.$t('global.general.to'),
                };
                if (view.numCreationInfos > 0) {
                    columns.createdBy = view.$t('global.menubar.messages.unapprovedAbsencesTableCreatedBy');
                }
                columns.actions = ' ';

                let data = Object.values(this.unapprovedPreferences);

                state = this.$helpers.GetDataTableStateFromKeyLabelObject(columns, data);

                view.$helpers.buildHeaderMapLabel(state.headerMap, 'employee');
                state.headerMap.employee.sort = true;
                function eName(data) {
                    return view.employees[data.employeeId] != undefined ? (view.employees[data.employeeId]
                        .lastName + ' ' + view.employees[data.employeeId].firstName) : '';
                }
                state.headerMap.employee.DisplayLabel = (data) => {
                    return eName(data) ;
                };
                state.headerMap.employee.componentStateBuilders = [(data) => {
                    return {
                        componentType: 'labelc',
                        state: {
                            text:  eName(data),
                        },
                        styleLabel: view.$helpers.styleLabel,
                    };
                }];

                view.$helpers.buildHeaderMapLabel(state.headerMap, 'absence');
                state.headerMap.absence.sort = true;
                function aType(data) {
                    return view.employeeAvailabilityTypeMap[data.type] != undefined ?
                        view.employeeAvailabilityTypeMap[data.type].label_de :
                        (view.employeeAvailabilityStateMap[data.state] != undefined ?
                            view.employeeAvailabilityStateMap[data.state].label_de : '')
                }
                state.headerMap.absence.DisplayLabel = (data) => {
                    return aType(data) ;
                };
                state.headerMap.absence.componentStateBuilders = [(data) => {
                    return {
                        componentType: 'labelc',
                        state: {
                            text: aType(data),
                        },
                        styleLabel: view.$helpers.styleLabel,
                    };
                }];

                view.$helpers.buildHeaderMapLabel(state.headerMap, 'month');
                state.headerMap.month.sort = true;
                function month(data) {
                    return view.$helpers.getMomentFromStringTZ(data.from).format('MMMM YYYY')
                }
                state.headerMap.month.DisplayLabel = (data) => {
                    return month(data);
                };
                state.headerMap.month.componentStateBuilders = [(data) => {
                    return {
                        componentType: 'labelc',
                        state: {
                            text: month(data),
                        },
                        styleLabel: view.$helpers.styleLabel,
                    };
                }];

                view.$helpers.buildHeaderMapLabel(state.headerMap, 'from');
                state.headerMap.from.sort = true;
                state.headerMap.from.componentStateBuilders = [(data) => {
                    return {
                        componentType: 'labelc',
                        state: {
                            text: view.$helpers.getMomentFromStringTZ(data.from).format('DD.MM.YYYY'),
                        },
                        styleLabel: view.$helpers.styleLabel,
                    };
                }];

                view.$helpers.buildHeaderMapLabel(state.headerMap, 'to');
                state.headerMap.to.sort = true;
                state.headerMap.to.componentStateBuilders = [(data) => {
                    return {
                        componentType: 'labelc',
                        state: {
                            text: view.getPrefToDate(data),
                        },
                        styleLabel: view.$helpers.styleLabel,
                    };
                }];

                if (view.numCreationInfos > 0) {
                    view.$helpers.buildHeaderMapLabel(state.headerMap, 'createdBy');
                    state.headerMap.createdBy.sort = true;
                    state.headerMap.createdBy.componentStateBuilders = [(data) => {
                        return {
                            componentType: 'labelc',
                            state: {
                                text: view.unapprovedPrefCreationInfo(data),
                            },
                            styleLabel: view.$helpers.styleLabel,
                        };
                    }];
                }

                state.headerMap.actions.stylesEntry = {'justify-content': 'left'};
                state.headerMap.actions.componentStateBuilders = [
                    (data) => {
                        if (!data) return {};
                        if (!data.approved) {
                            return {
                                componentType: 'buttonc',
                                tooltip: () => {
                                    return this.$t('global.ui.approve')
                                },
                                type: 'button icon-overlay square',
                                icon: "fas fa-check",
                                styleButton: {margin: '0 2px 0 2px'},
                                hideInput: !data || data.approved,
                                customEvents: {
                                    click: () => {
                                        view.$helpers.approvePreference(data, (response) => {
                                            data.approved = true;
                                            const index = this.unapprovedPreferences.indexOf(data);
                                            if (index !== -1) {
                                                this.unapprovedPreferences.splice(index, 1);
                                            }
                                        })
                                    }
                                }
                            }
                        }
                    },
                    (data) => {
                        if (!data) return {};
                        if (!data.denied) {
                            return {
                                componentType: 'buttonc',
                                tooltip: () => {
                                    return this.$t('global.ui.deny')
                                },
                                type: 'button icon-overlay square',
                                icon: "fas fa-file-times",
                                styleButton: {margin: '0 2px 0 2px'},
                                hideInput: !data || data.denied,
                                customEvents: {
                                    click: () => {
                                        view.$helpers.denyPreference(data, (response) => {
                                            data.denied = true;
                                            const index = this.unapprovedPreferences.indexOf(data);
                                            if (index !== -1) {
                                                this.unapprovedPreferences.splice(index, 1);
                                            }
                                        })
                                    }
                                }
                            }
                        }
                    },
                ];

                let entries = Object.entries(state.headerMap);

                let nameColumns = ['employee', 'createdBy'];
                let nameColumnWidth = 20;
                let mainColumns = ['absence','month','from','to', 'actions'];
                let mainColumnWidth = 15;
                for (let x in entries) {
                    if (nameColumns.includes(entries[x][0])) {
                        entries[x][1].width = nameColumnWidth + '%';
                    } else if (mainColumns.includes(entries[x][0])) {
                        entries[x][1].width = mainColumnWidth + '%';
                    }
                    entries[x][1].key = entries[x][0];
                }

                state.headerStyles = { fontSize: '12px', position: 'sticky', top: 0, zIndex: 10 };
                state.heightSubRow = 'fit-content';
                state.rowStyles = { background: '#6d8d23' };
                state.rowStylesCollapsed = { fontSize: '10px' };
                state.sumRowStyles = { background: 'var(--sub-menu)' };
                state.alwaysUnfold = false;
                return state;
            },
            declinedShiftsState() {
                let view = this;

                let state = {
                    headerMap: [],
                };

                let columns = {
                    employee: view.$tc('global.general.employee'),
                    day: view.$tc('global.general.day'),
                    from: view.$t('global.general.from'),
                    to: view.$t('global.general.to'),
                    status: view.$t('global.general.status'),
                };

                let data = Object.values(this.declinedShifts);

                state = this.$helpers.GetDataTableStateFromKeyLabelObject(columns, data);

                view.$helpers.buildHeaderMapLabel(state.headerMap, 'employee');
                state.headerMap.employee.sort = true;
                function eName(data) {
                    return view.employees[data.employeeId] != undefined ? (view.employees[data.employeeId]
                        .lastName + ' ' + view.employees[data.employeeId].firstName) : '';
                }
                state.headerMap.employee.DisplayLabel = (data) => {
                    return eName(data) ;
                };
                state.headerMap.employee.componentStateBuilders = [(data) => {
                    return {
                        componentType: 'labelc',
                        state: {
                            text:  eName(data),
                        },
                        styleLabel: view.$helpers.styleLabel,
                    };
                }];

                view.$helpers.buildHeaderMapLabel(state.headerMap, 'day');
                state.headerMap.day.sort = true;
                function day(data) {
                    return view.$helpers.extractDateString(data.from, 'DD.MM.YYYY');
                }
                state.headerMap.day.DisplayLabel = (data) => {
                    return day(data) ;
                };
                state.headerMap.day.componentStateBuilders = [(data) => {
                    return {
                        componentType: 'labelc',
                        state: {
                            text: day(data),
                        },
                        styleLabel: view.$helpers.styleLabel,
                    };
                }];

                view.$helpers.buildHeaderMapLabel(state.headerMap, 'from');
                state.headerMap.from.sort = true;
                state.headerMap.from.componentStateBuilders = [(data) => {
                    return {
                        componentType: 'labelc',
                        state: {
                            text: view.$helpers.extractDateStringTZ(data.from, 'HH:mm'),
                        },
                        styleLabel: view.$helpers.styleLabel,
                    };
                }];

                view.$helpers.buildHeaderMapLabel(state.headerMap, 'to');
                state.headerMap.to.sort = true;
                state.headerMap.to.componentStateBuilders = [(data) => {
                    return {
                        componentType: 'labelc',
                        state: {
                            text: view.$helpers.extractDateStringTZ(data.to, 'HH:mm'),
                        },
                        styleLabel: view.$helpers.styleLabel,
                    };
                }];

                view.$helpers.buildHeaderMapLabel(state.headerMap, 'status');
                state.headerMap.status.sort = true;
                function status(data) {
                    return view.uiData.planShiftStatuses ? view.uiData.planShiftStatuses
                        .find((s) => s.id == data.status).label_de : ""
                }
                state.headerMap.status.DisplayLabel = (data) => {
                    return status(data) ;
                };
                state.headerMap.status.componentStateBuilders = [(data) => {
                    return {
                        componentType: 'labelc',
                        state: {
                            text: status(data),
                        },
                        styleLabel: view.$helpers.styleLabel,
                    };
                }];

                let entries = Object.entries(state.headerMap);

                let nameColumns = ['employee'];
                let nameColumnWidth = 20;
                let mainColumns = ['day', 'from', 'to', 'status'];
                let mainColumnWidth = 15;
                for (let x in entries) {
                    if (nameColumns.includes(entries[x][0])) {
                        entries[x][1].width = nameColumnWidth + '%';
                    } else if (mainColumns.includes(entries[x][0])) {
                        entries[x][1].width = mainColumnWidth + '%';
                    }
                    entries[x][1].key = entries[x][0];
                }

                state.headerStyles = { fontSize: '12px', position: 'sticky', top: 0, zIndex: 10 };
                state.heightSubRow = 'fit-content';
                state.rowStyles = { background: '#6d8d23' };
                state.rowStylesCollapsed = { fontSize: '10px' };
                state.sumRowStyles = { background: 'var(--sub-menu)' };
                state.alwaysUnfold = false;
                return state;
            },
        },
        created(){
            window.menubar = this;
            this.checkForMaintenanceMode();
        },
        watch: {
            storeId(newVal, oldVal) {
               if(newVal){
                    let view = this;
                    this.$helpers.GetStoreSettings().then((storeSettings) => {
                        view.storeSettingsLoaded = true;

                        this.checkForUserNotifications();
                        view.$emit('LoadedStoreSettings');
                        if(this.rosterFromTo == null){
                            let date = view.$helpers.getCurrentMonthMomentTZ();
                            let rosterFromTo = this.$helpers.CalculateRosterFromTo(date);

                            view.$store.commit('setRosterFromTo', {rosterFromTo: rosterFromTo});
                        }

                        if(!view.$router.currentRoute.name) view.$router.push({name: 'landing', params: {storeId: view.$store.state.storeId}});
                    });

                   this.loadPermissions();
                   this.checkSuperUser();
                   this.checkOwner();
                   this.updateAnalytics();
               }
            },
            employeeAllUnapprovedPreferenceArray(newVal, oldVal){
                console.log('Unapproved preferences changed, updating in MenuBar');
                newVal.sort(this.sortUnapprovedPrefs);
                newVal = this.checkForPastUnapprovedWishes(newVal);
                //console.log(newVal);
                this.unapprovedPreferences = newVal.filter(pref => this.employeeMap[pref.employeeId] && this.employeeMap[pref.employeeId].active);
            },
            unapprovedPrefSortMode(newVal, oldVal){
                this.unapprovedPreferences.sort(this.sortUnapprovedPrefs);
            },
            employeeMap(newVal, oldVal){
                Object.keys(newVal).forEach(employeeId => {
                    this.employees[employeeId] = newVal[employeeId];
                });
                this.updateActiveEmployees();
                this.checkForEmployeesWithMissingPersonnelId();
            },
            employeeContractMap(newVal, oldVal){
                this.checkContracts(newVal);
                this.checkForEmployeesWithMissingContractDocuments(newVal);
                this.checkMissingAvailabilitesForParttimeEmployees();
            },

            employeeFilesMap: function(val, oldVal){

                let map = {};
                Object.values(this.employeeFilesMap).forEach(f => {
                    if(!map[f.employeeId]){
                        map[f.employeeId] = [];
                    }
                    map[f.employeeId].push(f);
                })
                this.employeeEmployeeFileMap = map;
                this.checkDocuments();
                this.checkNonEUWorkerDocuments();
                this.checkForEmployeesWithMissingContractDocuments(this.employeeContractMap);
            },
            storeSettings(newVal, oldVal){

                this.checkStoreLicense();
            },
            loggedIn(newVal, oldVal){
                if(newVal){
                    this.loadPermissions();
                    this.loadUserInfo();
                    this.checkSuperUser();
                    this.checkForStartupWarning();
                }
            },
            loggedInNoStores(newVal, oldVal){
                if(newVal)this.loadUserInfo();
            },
            activeStoreUsers(val, oldVal){
                var changed = val.length != oldVal.length;

                if(!changed){
                    // check if new item in val that's not present in oldVal
                    val.forEach((v) => {
                        var hasMatch = false;
                        oldVal.forEach((ov) => {
                            if(this.userInfosEqual(v, ov)){
                                hasMatch = true;
                                return;
                            }
                        });
                        if(!hasMatch){
                            // new item
                            changed = true;
                            return;
                        }
                    });
                }
                if(!changed){
                    // check other way round
                    oldVal.forEach((ov) => {
                        var hasMatch = false;
                        val.forEach((v) => {
                            if(this.userInfosEqual(ov, v)){
                                hasMatch = true;
                                return;
                            }
                        });
                        if(!hasMatch){
                            // item removed
                            this.$helpers.log(this, 'active store user removed');
                            changed = true;
                            return;
                        }
                    });
                }
                if(changed){
                    this.updateOnlineUserState();
                }
            },
            employeeAvailabilityMap(val, oldVal) {
                this.checkMissingAvailabilitesForParttimeEmployees();
            }
        },
        mounted() {
            this.updateMdReleaseVersion();
            this.initViewMode();
            if(this.supportsHTML5Storage()){
                this.localStorageSupported = true;
                this.$store.commit('setNightMode', localStorage.getItem('uimode') === '2');
            }
            let jwt = false;
            if(this.localStorageSupported){
                //get JWT from localstorage if it exists, store it in vuex then delete it from localstorage
                //this is needed for development environments were jwt needs to be set manually because our origin is localhost and cant be gotten from auth iframe
                jwt = localStorage.getItem('md_token');

                if(jwt != undefined){
                    this.$store.commit('setJWT', {jwt: jwt});
                    let host = window.location.host;
                    console.log(host);
                    if(!this.$helpers.isSafari() && !host.startsWith("localhost")){
                        localStorage.removeItem('md_token');
                    }
                }
            }

            let view = this;

            //let jwtqs = this.getQueryStringValue("jwt");
            let jwtqs = this.getJwtParam();
            //console.log('JWT FROM QUERY PARAM:');
            //console.log(jwtqs);

            if(!this.$helpers.isBlank(jwtqs)){
                jwt = jwtqs;
                localStorage.setItem("md_token", jwtqs)
                this.$store.commit('setJWT', {jwt: jwtqs});
            }

            if(this.$helpers.isSafari()){
                console.log('MD loading on Safari');
                if(jwt && jwt != 'null'){
                    let now = new Date().getTime() / 1000; // current time in seconds
                    var redirect = false;
                    var auth_ts = localStorage.getItem('auth_ts');
                    if(auth_ts && auth_ts != undefined && auth_ts != 'null'){
                        console.log('Auth timestamp found');
                        var age = now - auth_ts;
                        console.log('Auth token is ' + Math.trunc(age/60) + ' minutes old');
                        if(age > this.authValidity){
                            console.log('JWT older then allowed validity of ' + this.authValidity + ' seconds, removing token from storage');
                            localStorage.removeItem('md_token'); // redirect to check logged in user
                            redirect = true;
                        }
                    }else{
                        console.log('No auth timestamp found, removing token from storage');
                        localStorage.removeItem('md_token');
                        redirect = true;
                    }
                    if(redirect){
                        console.log('Setting auth timestamp');
                        localStorage.setItem('auth_ts', now);
                        // redirect to mdauth for tokencheck
                        console.log('Redirecting to MD Auth service at:');
                        console.log(this.loginUrl);
                        location.href = this.loginUrl;
                    }else{
                        view.login();
                    }
                }else{
                    window.location = this.loginUrl;
                }
            }else{
                if(!view.$helpers.isBlank(view.$store.state.jwt)){
                    view.login();
                } else{
                    window.location = this.loginUrl;
                }
            }


            // support chat bot bubble
            window.onload = function() {
                let frame = document.getElementById('authframe');

                // some browser (don't remember which one) throw exception when you try to access
                // contentWindow for the first time, it work when you do that second time
                try {
                    view.authframe = frame.contentWindow;
                } catch(e) {
                    view.authframe = frame.contentWindow;
                }



                window.onmessage = function(e) {
                    if (e.origin === "https://account.meindienstplan.at") {

                        let response = e.data;
                        //console.log(response);
                        if(response.key === "md_token"){
                            console.log("got token from account server")
                            view.$store.commit('setJWT', {jwt: response.data});
                            if(!view.$helpers.isBlank(view.$store.state.jwt) &&  !view.$store.state.loggedIn){
                                view.login();
                            }
                        }
                    }
                };
                // request JWT from auth iframe
                view.authframe.postMessage(JSON.stringify({key: 'md_token', method: "get"}), "*");
            };
        },
        methods: {
            updateAnalytics(userId = null){
                let view = this;
                // matomo analytics not in local dev environments
                if (window.location.href.includes("localhost")) {
                    console.log('Analytics not enabled in localhost environments');
                } else {
                    if(window._paq == undefined){
                        let full = window.location.host;
                        let parts = full.split('.');
                        let subdomain = parts[0];
                        let matomoSiteId = 2;
                        if (subdomain === "web") {
                            matomoSiteId = 1;
                        }
                        let uinfo = this.userInfo;
                        if(userId == null && uinfo != null && uinfo != undefined && 'email' in uinfo){
                            userId = this.userInfo.email;
                        }
                        if(userId != null){
                            console.log('Enabling siteId ' + matomoSiteId);
                            Vue.config.productionTip = false;
                            Vue.use(VueMatomo, {
                                host: "https://analytics.meindienstplan.at/",
                                siteId: matomoSiteId,
                                trackerFileName: 'matomo',
                                router: this.$router,
                                enableLinkTracking: true,
                                requireConsent: false,
                                trackInitialView: true,
                                disableCookies: true,
                                enableHeartBeatTimer: true,
                                heartBeatTimerInterval: 15,
                                debug: false,
                                userId: userId
                            });
                        }
                    }
                    view.trackStoreIdDimension();
                }
            },
            trackStoreIdDimension(){
                if(window._paq != undefined){
                    const storeId = this.$store.state.storeId;
                    console.log('Tracking dimension value ' + storeId);
                    window._paq.push(['setCustomDimension', 1, '' + storeId]);
                }else{
                    console.log('Skip tracking store ID dimension, tracker not initialized!');
                }
            },
            getTextColor(value) {
                if(value == null || value === "") {
                    return "color: var(--col-red-text)";
                }
            },
            checkForMaintenanceMode(){
                var ts = new Date().getTime();
                console.log('Checking for maintenance mode');
                this.axios.get('/maintenance?ts=' + ts).then((response) => {
                    if("maintenance" in response.data){
                        console.log("Maintenance mode: " + response.data.maintenance);
                        if(response.data.maintenance){
                            window.location.href = 'https://kundencenter.meindienstplan.at/maintenance.html';
                        }
                    }
                });
            },
            checkForStartupWarning(){
                if(!this.warningShown && this.$helpers.isSafari()){
                    this.modalStartup = true;
                    this.warningShown = true;
                }
            },
            compareAlphaNum( a , b ){
                var reA = /[^a-zA-Z]/g;
                var reN = /[^0-9]/g;
                var aA = a.label.replace(reA, "");
                var bA = b.label.replace(reA, "");
                if (aA === bA) {
                    var aN = parseInt(a.label.replace(reN, ""), 10);
                    var bN = parseInt(b.label.replace(reN, ""), 10);
                    return aN === bN ? 0 : aN > bN ? 1 : -1;
                } else {
                    return aA > bA ? 1 : -1;
                }
            },
            unapprovedPrefCreationInfo(pref){
                let info = "";
                let featureGoneLive = this.$helpers.getMomentFromValues(2021, 8, 3);
                if(pref.createdAt && this.$helpers.getMomentFromString(pref.createdAt)._d.getTime() > featureGoneLive._d.getTime()) info = this.$helpers.extractDateStringTZ(pref.createdAt, 'DD.MM.YYYY');
                if(pref.createdByName && pref.createdByName.length > 0) info += " (" + pref.createdByName + ")";
                return info;
            },
            getUnapprovedPrefSortOptions() {
              return [
                { text: this.$t('global.menubar.sortOptionCreationDate'), value: 0, size: "sm"},
                { text: this.$t('global.menubar.sortOptionAbsenceDate'), value: 1, size: "sm"},
                { text: this.$t('global.menubar.sortOptionEmployee'), value: 2, size: "sm"},
              ];
            },
            getDeclinedShiftsSortOptions() {
              return [
                { text: this.$t('global.menubar.sortOptionEmployee'), value: 0, size: "sm"},
                { text: this.$t('global.menubar.sortOptionShiftStart'), value: 1, size: "sm"},
                { text: this.$t('global.menubar.sortOptionShiftStatus'), value: 2, size: "sm"},
              ];
            },
            sortUnapprovedPrefs(a,b){
                let aTime, bTime;
                let aFrom = this.$helpers.getMomentFromString(a.from)._d.getTime();
                let bFrom = this.$helpers.getMomentFromString(b.from)._d.getTime();
                if(this.unapprovedPrefSortMode == 2){
                    //console.log('Sorting by employee name');
                    let emplA = this.employeeMap[a.employeeId];
                    let emplB = this.employeeMap[b.employeeId];
                    return emplA.lastName.toLowerCase() + ' ' + emplA.firstName.toLowerCase() < emplB.lastName.toLowerCase() + ' ' + emplB.firstName.toLowerCase() ? -1 : +1
                }else{
                    if(this.unapprovedPrefSortMode == 0){
                        //console.log('Sorting by creation date');
                        if(a.createdAt){
                            let aDate = this.$helpers.getMomentFromString(a.createdAt);
                            aTime = aDate._d.getTime();
                        }
                        if(b.createdAt){
                            let bDate = this.$helpers.getMomentFromString(b.createdAt);
                            bTime = bDate._d.getTime();
                        }
                        if(aTime && bTime){
                            if(aTime > bTime) return -1;
                            if(bTime > aTime) return 1;
                            return 0;
                        }else if(aTime && !bTime){
                            return -1;
                        }else if(bTime && !aTime){
                            return 1;
                        }
                    }
                    console.log('Sorting by pref date for mode ' + this.unapprovedPrefSortMode);
                    // no createdAt date present in both or sortMode == 1
                    if(aFrom > bFrom) return -1;
                    if(bFrom > aFrom) return 1;
                    return 0;
                }
                // console.log('Came to the very end of sorting unapproved prefs and I think that is not good!');
                // return 0;
            },
            OpenUserMenu($event){
                let newsCallback = this.loggedInNoStores? null : () => { view.navigateTo('employeedatarequestoverview') };
                let eventLogCallback = this.loggedInNoStores? null : () => { VueEventBus.$emit("toggle-eventlog", true) };
                let view = this;
                this.$helpers.OpenPopup({
                    type: 'menudetails',
                    componentState: {
                        pictureUrl: view.my_image,
                        name: view.userFullname,
                        News: newsCallback,
                        MyAccount: () => {
                            window.location = "https://account.meindienstplan.at";
                        },
                        About: () => {
                            view.openAbout();
                        },
                        EventLog: eventLogCallback,
                        SignOut: view.logout,
                        //eventNumber: view.eventNumber,
                    },
                    expanded: true,
                    noScroll: true,
                    elRelative: $event.currentTarget,
                    pointerDirection: 0,
                });
            },
            isActive(link){
                var cur = this.$router.currentRoute;
                return cur.name == link.name;
            },
            updateOnlineUserState(){
                let entries = {};
                let hiddenList = this.activeStoreUsers.slice();
                if(!this.$store.state.isSuperUser){
                    hiddenList = hiddenList.filter(u => !u.hidden);
                }
                let usersFiltered = hiddenList;
                let view = this;
                usersFiltered.sort((a, b) => {
                   return view.$helpers.getMomentFromStringTZ(a.date) > view.$helpers.getMomentFromStringTZ(b.date) ? 1 : -1;
                });
                usersFiltered = usersFiltered.slice(0, 10);
                usersFiltered.forEach(u => {
                    entries[u.id] = {
                        key: u.id,
                        label: '',
                        value: u.name,
                        type: 'text',
                    };
                });

                if(hiddenList.length > 10) {
                    entries['-'] = {
                        key: '-',
                        label: '',
                        value: '...',
                        type: 'text',
                    };
                }
                this.OnlineUserState.componentState.entries = Object.assign({}, entries);
            },
            userInfosEqual(a, b){
                var objectsAreSame = true;
                for(var propertyName in a) {
                    if(a[propertyName] !== b[propertyName]) {
                        objectsAreSame = false;
                        break;
                    }
                }
                return objectsAreSame;
            },
            initViewMode(){
                var mode = localStorage.getItem('uimode');
                let body = document.getElementsByTagName('body')[0];
                if(mode != undefined){
                    mode = parseInt(mode);
                    switch(mode){
                        case 1:
                            body.classList.add("daymode");
                            break;
                        case 2:
                            body.classList.add("nightmode");
                            break;
                        default:
                            body.classList.add("daymode");
                    }
                }else{
                    mode = 1
                    body.classList.add("daymode");
                    localStorage.setItem('uimode', mode);
                }
            },
            toggleDarkMode(){
                var mode = 0;
                let body = document.getElementsByTagName('body')[0];
                if(body.classList.length > 0) {
                    var cur = body.classList[0];
                    if(cur == "nightmode"){
                        body.classList.remove("nightmode");
                        body.classList.add("daymode");
                        mode = 1;
                    }else if(cur == "daymode"){
                        body.classList.remove("daymode");
                        body.classList.add("nightmode");
                        mode = 2;
                    }
                }else{
                    mode = localStorage.getItem('uimode');
                    if(mode != undefined){
                        mode = parseInt(mode);
                        switch(mode){
                            case 1:
                                body.classList.add("daymode");
                                break;
                            case 2:
                                body.classList.add("nightmode");
                                break;
                            default:
                                body.classList.add("daymode");
                        }
                    }else{
                        mode = 1;
                        body.classList.add("daymode");
                    }
                }
                localStorage.setItem('uimode', mode);
                this.$store.commit('setNightMode', (mode === 2));
            },
            toggleAnonMode(){
                this.$store.commit('setAnonMode', !this.anonMode);
            },
            loadPermissions: function() {
                let view = this;
                let url = '/api/sec/permission/me';
                let params = {
                   storeId: view.$store.state.storeId,
                }
                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                }).then(response => {
                    return new Promise((resolve, reject) => {
                        let permissions = {};
                        for (let i = 0; i<response.data.length; i++){
                            if(!permissions[response.data[i].roleId]){
                                permissions[response.data[i].roleId] = []
                            }
                            permissions[response.data[i].roleId].push(response.data[i]);
                        }

                        view.$store.commit('setPermissions', {permissions: permissions});


                        resolve("SUCCESS")

                    })

                }).catch(function (error) {
                    return new Promise((resolve, reject) => {

                        reject(error)

                    })
                })
            },
            checkSuperUser: function() {
                let view = this;
                let url = '/api/sec/permission/me/superuser';
                let params = {
                   storeId: view.$store.state.storeId,
                }
                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                }).then(response => {
                    return new Promise((resolve, reject) => {

                        view.$store.commit('setIsSuperUser', {isSuperUser: true});
                        resolve("SUCCESS")

                    })

                }).catch(function (error) {
                    return new Promise((resolve, reject) => {
                        view.$store.commit('setIsSuperUser', {isSuperUser: false});
                        resolve("SUCCESS");

                    })
                })
            },
            checkOwner: function() {
                let view = this;
                let url = '/api/sec/userrole/me/owner';
                let params = {
                   storeId: view.$store.state.storeId,
                }
                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                }).then(response => {
                    return new Promise((resolve, reject) => {

                        view.$store.commit('setIsOwner', {isOwner: true});
                        resolve("SUCCESS")

                    })

                }).catch(function (error) {
                    return new Promise((resolve, reject) => {
                        view.$store.commit('setIsOwner', {isOwner: false});
                        resolve("SUCCESS");

                    })
                })
            },
            loadStores : function() {
                let view = this;
                let url = '/api/semi/stores/useronly';

                return this.axios({
                    method: 'get',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                }).then(response => {
                    return new Promise((resolve, reject) => {
                        let selectedItem = {};
                        view.processedStores = [];
                        if(response.data.length == 0){
                            this.modalNopermissions = true;
                            view.loggedInNoStores = true;
                        }else{
                            let sortedStores = response.data.sort((a, b) => a.name.localeCompare(b.name));
                            if(!view.$store.state.storeId){
                                let items = Object.assign([], sortedStores);
                                let first = null;
                                // get first store that is not disabled
                                const filteredItems = items.filter((item) => !item.disabled);
                                if(filteredItems.length > 0){
                                    // select first not disabled store
                                    first = filteredItems[0];
                                }else{
                                    // no active stores available, select first of available disabled stores to avoid breaking things here :-D
                                    first = sortedStores[0];
                                }

                                view.$store.commit('setStoreId', {storeId: first.id});
                                view.$store.commit('setStoreData', {storeData: first});
                                view.$store.commit('setCompanyId', {companyId: first.companyId});
                            } else {
                                let storeData = response.data.find(s => view.$store.state.storeId == s.id);
                                if(storeData){
                                    view.$store.commit('setStoreId', {storeId: storeData.id});
                                    view.$store.commit('setStoreData', {storeData: storeData});
                                    view.$store.commit('setCompanyId', {companyId: storeData.companyId});
                                } else {
                                    let items = Object.assign([], sortedStores);
                                    let first = null;
                                    // get first store that is not disabled
                                    const filteredItems = items.filter((item) => !item.disabled);
                                    if(filteredItems.length > 0){
                                        // select first not disabled store
                                        first = filteredItems[0];
                                    }else{
                                        // no active stores available, select first of available disabled stores to avoid breaking things here :-D
                                        first = sortedStores[0];
                                    }

                                    view.$store.commit('setStoreId', {storeId: first.id});
                                    view.$store.commit('setStoreData', {storeData: first});
                                    view.$store.commit('setCompanyId', {companyId: first.companyId});
                                }
                            }

                            sortedStores.forEach(x =>{
                                let ss = x;
                                let latitude = ss.latitude != null ? parseFloat(ss.latitude).toFixed(2)  : null;
                                let longitude = ss.longitude != null ? parseFloat(ss.longitude).toFixed(2)  : null;
                                let entry = {label: ss.name,
                                             id: ss.id,
                                             companyId: ss.companyId,
                                             description: ss.description ? ss.description : '',
                                             disabled: ss.disabled,
                                             latitude: latitude,
                                             longitude: longitude};
                                if(entry.id == view.$store.state.storeId) {
                                    selectedItem = entry
                                    view.$store.commit('setStoreData', {storeData: entry});
                                }
                                view.processedStores.push(entry);
                            })
                            view.processedStores.sort(view.compareAlphaNum);
                            view.$store.commit("setSelectableStores", {selectableStores: view.processedStores});
                            selectedItem.selected = true;

                        }

                        resolve("SUCCESS")
                    })

                }).catch(function (error) {
                    console.log(error);
                    return new Promise((resolve, reject) => {

                        reject(error)

                    })
                })
            },
            loadUserInfo: function(){
                let view = this;
                let url = '/api/semi/user/me';
                let params = {
                   storeId: view.$store.state.storeId,
                }
                this.axios({
                    method: 'get',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    params: params
                }).then(response => {
                    let userInfo = {
                        firstname: response.data.firstname,
                        lastname: response.data.lastname,
                        email: response.data.email,
                        image_url:  response.data.profileimage ? response.data.profileimage.url : null,
                        id: response.data.id
                    };

                    view.$store.commit("setUserInfo", {userInfo: userInfo});

                    view.updateAnalytics(userInfo.email);

                    if(response.data.profileimage){
                        view.my_image = view.userInfo.image_url;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            Init: function (styles) {
                this.styles = styles;
            },
            ToggleCollapse: function ($event) {
                var event = $event;
                event.currentTarget.parentElement.classList.toggle("show");
            },
            OpenNavMenu($event){
                let view = this;
                let labels = [];
                this.computedIconsMain.forEach(icon => {
                   labels.push({
                       text: icon.label,
                       type: 'block',
                       icon: icon.icon,
                       click: () => {
                           window.open(icon.externalLink, '_blank');
                       }
                   });
                });
                this.$helpers.OpenPopup({
                    type: 'listlabel',
                    componentState: {
                        labels: labels,
                    },
                    listStyle: true,
                    noScroll: true,
                    pointerDirection: 0,
                    elRelative: $event.currentTarget,
                    pointerOffset: -15,
                });
            },
            ToggleDropDown: function ($event, selection, offsetx, offsety, pointerOffset) {
                if (!selection || selection.length === 0) return;
                var event = $event;
                var box = event.currentTarget.getBoundingClientRect();
                var dropdowns = this.dropdowns;
                if (selection === this.iconsNav && window.innerWidth <= 750) {
                    selection = this.iconsNavCollapsed;
                }
                selection = selection.map(item => item.labelKey ? { ...item, label: this.$t(item.labelKey)} : item);
                this.dropdowns.push({
                    items: selection,
                    el: event.currentTarget,
                    remainAfterSelect: true,
                    toggled: true,
                    offsetx: offsetx,
                    offsety: offsety,
                    posx: box.left + offsetx,
                    posy: box.bottom + offsety,
                    pointerOffset: pointerOffset,
                    onceSelected: function ($eventInner, item, dropdown) {
                        if (item.items && item.items.length > 0) {
                            var eventInner = $eventInner;
                            var boxInner = eventInner.currentTarget.getBoundingClientRect();
                            var temp = {
                                items: item.items,
                                el: eventInner.currentTarget,
                                offsetx: offsetx + 130,
                                offsety: offsety - 30,
                                posx: box.left + offsetx + 130,
                                toggled: true,
                                posy: boxInner.bottom - 30,
                                pointerDirection: 3,
                                pointerOffset: pointerOffset,
                                parentCallback: function () {
                                    dropdown.toggled = false
                                }
                            };
                            dropdowns.push(temp);
                        }
                    }
                });
            },
            ToggleDropDownMenuNav: function ($event, selection, offsetx, offsety) {
                var event = $event;
                var box = event.currentTarget.getBoundingClientRect();
                var dropdowns = this.dropdowns;
                var temp = {
                    el: event.currentTarget,
                    offsetx: offsetx,
                    offsety: offsety,
                    posx: box.left + offsetx,
                    posy: box.bottom + offsety,
                    items: selection.items,
                    toggled: true,
                    onceSelected: function ($eventInner, item, dropdown) {
                        dropdowns = dropdowns.filter(d => d !== temp);
                    }
                };
                this.dropdowns.push(temp);
                /*this.$refs.dropdown.Init(selection.items, {
                    el: event.currentTarget,
                    posx: box.left + offsetx,
                    posy : box.bottom + offsety,
                });*/
            },
            ToggleDropDownUser: function ($event, user, offsetx, offsety) {
                var event = $event;
                var box = event.currentTarget.getBoundingClientRect();
                this.$refs.dropdown.posx = box.left + offsetx;
                this.$refs.dropdown.posy = box.bottom + offsety;
                this.$refs.dropdown.items = user.items;
                this.$refs.dropdown.onceSelected = function () {
                    this.$forceUpdate()
                };
                this.$refs.dropdown.toggle();
            },
            ToggleDropDownLogin: function ($event, user, offsetx, offsety) {
                var event = $event;
                var box = event.currentTarget.getBoundingClientRect();
                this.$refs.dropdownlogin.posx = box.left + offsetx;
                this.$refs.dropdownlogin.posy = box.bottom + offsety;
                this.$refs.dropdownlogin.onceSelected = function () {
                    this.$forceUpdate()
                };
                this.$refs.dropdownlogin.toggle();
            },
            RouterTo(destination) {
                this.$router.push(destination)
                this.$forceUpdate();
                //this.$router.replace(destination)
            },
            navigateTo(destination) {
                this.$router.push({ name: destination, params: { storeId: this.$store.state.storeId } })
                //this.$router.replace(destination)
            },
            getJwtParam(){
                let url = window.location.href;
                if(url.includes("jwt=")){
                    let subIndex = url.indexOf("jwt=") + 4;
                    return url.substring(subIndex);
                }
                return null;
            },
            getQueryStringValue: function (key) {
                console.log('Extracting query param: ' + key);
                let url = new URL(window.location.href);
                console.log(window.location.href);
                let searchParams = new URLSearchParams(url.search);
                searchParams.forEach((p) => {
                    console.log(p);
                });
                return searchParams.get(key);
                //return decodeURIComponent(window.location.search.replace(new RegExp('^(?:.*[&\\?]' + encodeURIComponent(key).replace(/[\.\+\*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$', 'i'), '$1'));
            },
            supportsHTML5Storage: function () {
                try {
                    return 'localStorage' in window && window['localStorage'] !== null;
                } catch (e) {
                    return false;
                }
            },
            checkStoreLicense(navigatePath = null){
                console.log('Checking license in store settings');
                let view = this;
                if(this.storeSettings != null && this.storeSettings.licExpiry != null){
                    let licExpiry = this.storeSettings.licExpiry;
                    let licMoment = this.$helpers.getMomentFromStringTZ(licExpiry).add(72, 'hours');
                    let now = this.$helpers.getMomentTZ();
                    if(now < licMoment){
                        this.licenseValid = true;
                        if(navigatePath != null) this.navigateTo(navigatePath);
                    }else{
                        console.log('MenuBar :: license not valid - showing modal');
                        this.licenseValid = false;
                        this.modalNolicense = true;
                    }
                    console.log('valid: ' + this.licenseValid);
                    this.$forceUpdate();
                } else{
                    view.$helpers.OpenAlert({
                        header: this.$t('global.menubar.messages.noPermissionHeader'),
                        description: this.$t('global.menubar.messages.noPermissionBody'),
                        disableAccept: true,
                        cancelLabel: this.$t('global.ui.close'),
                    });
                    console.log('Store settings NULL');
                }
            },
            login: function() {
                let view = this;
                if(!this.$helpers.isBlank(this.$store.state.jwt)){
                    let url = '/api/login';

                    this.axios({
                        method: 'get',
                        headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                        },
                        url: url
                    }).then(response => {
                        //view.$store.commit('setJWT', {jwt: jwt});
                        view.loadStores().then(success=>{
                            //only really log in after stores are loaded
                            if(!view.loggedInNoStores){
                                return view.$helpers.GetStoreSettings().then((storeSettings) => {
                                    view.storeSettingsLoaded = true;
                                    view.$emit('LoadedStoreSettings');
                                    let date = view.$helpers.getCurrentMonthMomentTZ();
                                    let rosterFromTo = this.$helpers.CalculateRosterFromTo(date);
                                    //console.log("MENU BAR ROSTER FROMTO: "+JSON.stringify(rosterFromTo))
                                    view.$store.commit('setRosterFromTo', {rosterFromTo: rosterFromTo});
                                    if(!view.$router.currentRoute.name) view.$router.push({name: 'landing', params: {storeId: view.$store.state.storeId}});
                                });
                            }
                        }).then(success => {
                            return view.loadPermissions();
                        }).then(success => {
                            return view.checkSuperUser();
                        }).then(success => {
                            view.$store.dispatch('initConfigStates');
                            return view.checkOwner();
                        }).then(success => {
                            view.$store.commit('setLoggedIn', {loggedIn: true});
                            view.$helpers.LoadMaps();
                            let path = 'landing';
                            if(this.$router.currentRoute) {
                                console.log(this.$router.currentRoute);
                                console.log(this.$router.currentRoute);

                                path = this.$router.currentRoute.name;
                            }
                            view.checkStoreLicense(path);
                            view.checkForUserNotifications();
                        }).catch(error => {
                            //Something went wrong => maybe user doesnt have permission for selected store
                            // => clear localstorage

                            localStorage.removeItem('selected_store');
                            localStorage.removeItem('selected_company');
                            view.$store.commit('setStoreId', {storeId: null});
                            view.checkForStartupWarning();
                            //TODO: navigate to a startpage but iwthout auto login
                        })



                    }).catch(function (error) {
                        view.$store.commit('clearJWT');
                        if(view.authframe != null){
                            console.log("clearing jwt in auth frame");
                            view.authframe.postMessage(JSON.stringify({key: 'md_token', method: "remove"}), "*");
                        }
                        if(view.$route.name != "home"){
                            console.log("going home");
                            view.navigateTo('home');
                        }
                        /* view.$helpers.error('Fehler', 'Login fehlgeschlagen'); */
                        window.location = view.loginUrl;
                    })
                } else {
                    window.location = view.loginUrl;
                }
            },
            checkForUserNotifications(){
                this.notificationLoadingState = 0;

                // load general stuff first that is needed by other loading routines
                this.$helpers.GetEmployeeMap().then(employees => {
                    this.employees = employees;
                    this.updateActiveEmployees();
                    this.checkForEmployeesWithMissingPersonnelId();
                    this.$helpers.GetUiDataMap().then(data => {
                        this.uiData = data;
                        //console.log(data);
                        let typeMap = {};
                        let stateMap = {};
                        let exitMap = {};
                        for(let i = 0; i < data.employeeAvailabilityTypes.length; i++){
                            let employeeAvailabilityType = data.employeeAvailabilityTypes[i];
                            typeMap[employeeAvailabilityType.id] = employeeAvailabilityType;
                        }
                        for(let i = 0; i < data.employeeAvailabilityStates.length; i++){
                            let employeeAvailabilityState = data.employeeAvailabilityStates[i];
                            stateMap[employeeAvailabilityState.id] = employeeAvailabilityState;
                        }
                        for(let i = 0; i < data.exitReasons.length; i++){
                            let reason = data.exitReasons[i];
                            exitMap[reason.id] = reason;
                        }
                        this.employeeAvailabilityTypeMap = typeMap;
                        this.employeeAvailabilityStateMap = stateMap;
                        this.exitReasonsMap = exitMap;
                        this.notificationLoadingState++;

                        // load data and check for notifications
                        this.loadUnapprovedPreferencesNotificationData();

                        this.loadContractAndDocumentNotificationData();
                        this.checkMissingDataForUnderagedEmployees();
                        this.$helpers.GetEmployeeAvailabilityMap()
                          .then(r => {
                              this.checkMissingAvailabilitesForParttimeEmployees();
                          });
                        this.$helpers.GetShiftStatusLogMap();
                    });
                });
            },
            loadUnapprovedPreferencesNotificationData(){
                this.$helpers.GetEmployeeAllUnapprovedPreferenceMap(true, true).then(preferences => {
                    preferences.sort(this.sortUnapprovedPrefs);
                    preferences = this.checkForPastUnapprovedWishes(preferences);
                    this.unapprovedPreferences = preferences.filter(pref => this.employeeMap[pref.employeeId] && this.employeeMap[pref.employeeId].active);
                    this.notificationLoadingState++;
                });
            },
            checkForPastUnapprovedWishes(preferences){
                if(preferences){
                    var now = new Date();
                    for(var i = preferences.length-1; i >= 0; i--){
                        let p = preferences[i]
                        if([3,4].includes(p.state)){ // desired or undesired
                            let toDate = new Date(p.to);
                            if (toDate < now) {
                                // unapproved preference is a whish (desired/undesired) that is in the past
                                delete preferences[i];
                            }
                        }
                    }
                }

                return preferences;
            },
            loadContractAndDocumentNotificationData(){
                //contract doc check depends on files, so we do it one check
                this.$helpers.GetEmployeeFilesMap().then(fmap => {
                    let map = {};
                    Object.values(fmap).forEach(f => {
                        if(!map[f.employeeId]){
                            map[f.employeeId] = [];
                        }
                        map[f.employeeId].push(f);
                    })
                    this.employeeEmployeeFileMap = map;
                    this.checkDocuments();
                    this.checkNonEUWorkerDocuments();

                    this.notificationLoadingState++;
                    return this.$helpers.GetEmployeeContractMap();
                }).then(contracts => {
                    this.checkContracts(contracts);
                    this.checkForEmployeesWithMissingContractDocuments(contracts);
                    this.notificationLoadingState++;
                });

            },

            updateActiveEmployees(){

                let activeEmpl = {};
                if(this.employees){
                    Object.values(this.employees).forEach(e => {
                        if(e.active) activeEmpl[e.id] = e;
                    });
                }
                this.activeEmployeesMap = activeEmpl;
            },
            checkContracts(contracts){
                if(contracts){
                    let view = this;
                    //console.log(contracts);
                    let expiringSoon = [];
                    let config = this.notificationBellConfigState;
                    let now = this.$helpers.getCurrentMoment();
                    let soonInterval = 56;
                    if(config.contractExpiryLimit){
                        soonInterval = Math.max(1, config.contractExpiryLimit);
                    }
                    let soonDate = now.clone().add(soonInterval, "days");
                    let expired = [];
                    Object.values(contracts).forEach(c => {
                        let emplId = c.employeeId;
                        if(emplId in this.activeEmployeesMap){
                            let to = null;
                            let from = this.$helpers.getMomentFromStringTZ(c.from);
                            if(c.to){
                                to = this.$helpers.getMomentFromStringTZ(c.to);
                                if(from < now && to > now && to <= soonDate){
                                    expiringSoon.push(c);
                                }else if(to <= now){
                                    expired.push(c);
                                }
                            }
                        }
                    });
                    expired = expired.sort((a, b) => {
                        let aDate = view.$helpers.getMomentFromStringTZ(a.to);
                        let bDate = view.$helpers.getMomentFromStringTZ(b.to);
                        return aDate.unix() - bDate.unix();
                    })

                    expiringSoon = expiringSoon.sort((a, b) => {
                        let aDate = view.$helpers.getMomentFromStringTZ(a.to);
                        let bDate = view.$helpers.getMomentFromStringTZ(b.to);
                        return aDate.unix() - bDate.unix();
                    })
                    //console.log(expiringSoon);
                    this.expiringContracts = expiringSoon;
                }
            },
            checkForEmployeesWithMissingContractDocuments(contracts = null){
                if(!this.hasSharepoint){
                    console.log('Checking for missing contract documents...');
                    let emplIdsWithContractDoc = [];
                    let emplIdMissinDoc = [];
                    let emplIdsWithActiveContract = [];
                    let now = this.$helpers.getCurrentMoment();
                    if(contracts){
                        Object.values(contracts).forEach(c => {
                            let emplId = c.employeeId;

                            if(emplId in this.activeEmployeesMap){
                                let to = null;
                                if(c.to){
                                    to = this.$helpers.getMomentFromStringTZ(c.to);
                                }
                                if((to == null || to > now)){

                                    emplIdsWithActiveContract.push(emplId);
                                    // current or future contract
                                    if(c.fileId != null){
                                        emplIdsWithContractDoc.push(emplId);
                                    }
                                }
                            }
                        });
                    }

                    Object.values(this.activeEmployeesMap)
                    .sort((a, b) => {
                        let aName = a.lastName + " " + a.firstName;
                        let bName = b.lastName + " " + b.firstName;
                        return aName.localeCompare(bName);
                    }).forEach((employee) => {
                        let eId = employee.id;
                        if(!(emplIdsWithContractDoc.includes(eId)) && emplIdsWithActiveContract.includes(eId) && !employee.dummy){

                            let files = (eId in this.employeeEmployeeFileMap)? this.employeeEmployeeFileMap[eId] : [];
                            let foundDoc = false;
                            files.forEach((f) => {
                                let type = f.documentType;
                                if(type == "CONTRACT"){
                                    let validUntil = null;
                                    if(f.validUntil){
                                        validUntil = this.$helpers.getMomentFromStringTZ(f.validUntil);
                                    }
                                    if(validUntil == null || validUntil > now){
                                        // valid contract doc
                                        foundDoc = true;
                                    }
                                }
                            });
                            if(!foundDoc){
                                if(!(emplIdMissinDoc.includes(eId))){
                                    emplIdMissinDoc.push(eId);
                                }
                            }
                        }
                    });
                    emplIdMissinDoc.sort((ida,idb) => {
                        let a = this.employees[ida];
                        let b = this.employees[idb];
                        if(a.lastName > b.lastName) return 1;
                        if(b.lastName > a.lastName) return -1;
                        if(a.lastName == b.lastName){
                            if(a.firstName > b.firstName) return 1;
                            if(b.firstName > a.firstName) return -1;
                        }
                        return 0;
                    });
                    //console.log(emplIdMissinDoc)
                    this.missingContractDocuments = emplIdMissinDoc;
                }else{
                    this.missingContractDocuments = [];
                }


            },
            checkForEmployeesWithMissingPersonnelId(contracts = null){
                console.log('Checking for missing personnel Ids...');

                let emplIdMissingPersonnelId = [];



                Object.values(this.activeEmployeesMap)
                .sort((a, b) => {
                    let aName = a.lastName + " " + a.firstName;
                    let bName = b.lastName + " " + b.firstName;
                    return aName.localeCompare(bName);
                }).forEach((employee) => {
                    if(this.$helpers.isEmpty(employee.personnelId) && !employee.dummy){
                        emplIdMissingPersonnelId.push(employee.id);
                    }
                });
                emplIdMissingPersonnelId.sort((ida,idb) => {
                        let a = this.employees[ida];
                        let b = this.employees[idb];
                        if(a.lastName > b.lastName) return 1;
                        if(b.lastName > a.lastName) return -1;
                        if(a.lastName == b.lastName){
                            if(a.firstName > b.firstName) return 1;
                            if(b.firstName > a.firstName) return -1;
                        }
                        return 0;
                });

                this.missingPersonnelIds = emplIdMissingPersonnelId;


            },
            checkNonEUWorkerDocuments(){

                let missingPass = [];
                let missingWorkPermit = [];
                let missingResidencePermit = [];
                let missingEducationPermit = [];

                //let config = this.notificationBellConfigState;


                Object.values(this.activeEmployeesMap).filter(e => {

                    return e.citizenType != null && (e.citizenType == 2 || e.citizenType == 5) && !e.dummy;
                }).sort((a, b) => {
                    let aName = a.lastName + " " + a.firstName;
                    let bName = b.lastName + " " + b.firstName;
                    return aName.localeCompare(bName);
                }).forEach(e => {
                    if(!this.employeeEmployeeFileMap[e.id]){
                        if(e.citizenType != 5){
                            missingPass.push(e.id);
                        }

                        missingWorkPermit.push(e.id);
                        missingResidencePermit.push(e.id);
                        missingEducationPermit.push(e.id);
                    } else {
                        if(e.citizenType != 5 && this.employeeEmployeeFileMap[e.id].filter(f => f.documentType == 'PASSPORT' || f.documentType == 'ASYLUMPASS' || f.documentType == 'ID').length == 0){
                            missingPass.push(e.id);
                        }
                        if(this.employeeEmployeeFileMap[e.id].filter(f => f.documentType == 'WORKPERMIT' || f.documentType == 'RESIDENCEWORKPERMIT' || f.documentType == 'ASYLUMPASS').length == 0){
                            missingWorkPermit.push(e.id);
                        }
                        if(this.employeeEmployeeFileMap[e.id].filter(f => f.documentType == 'RESIDENCEPERMIT' || f.documentType == 'RESIDENCEWORKPERMIT' || f.documentType == 'ASYLUMPASS').length == 0){
                            missingResidencePermit.push(e.id);
                        }
                        if(this.employeeEmployeeFileMap[e.id].filter(f => f.documentType == 'EDUCATIONCERTIFICATE').length == 0){
                            missingEducationPermit.push(e.id);
                        }

                    }
                })
                this.missingPassDocs = missingPass;
                this.missingWorkPermitDocs = missingWorkPermit;
                this.missingResidencePermitDocs = missingResidencePermit;
                this.missingEducationPermitDocs = missingEducationPermit
            },
            checkDocuments(){
                let view = this;
                let expiringSoon = [];
                let expired = [];
                let unconfirmed = [];
                let config = this.notificationBellConfigState;
                let onlyCheckDocumentTypes = config.checkOnlyDocumentTypes;
                let now = this.$helpers.getMoment();
                let soonInterval = 56;
                if(config.documentExpiryLimit){
                    soonInterval = Math.max(1, config.documentExpiryLimit);
                }
                let soonDate = now.clone().add(soonInterval, "days");
                Object.values(this.activeEmployeesMap).forEach(e => {
                    let files = this.employeeEmployeeFileMap[e.id] ? this.employeeEmployeeFileMap[e.id] : [];
                    let validFiles = [];
                    let confirmedFiles = [];
                    let filesToValid = [];
                    let filesToConfirm = [];
                    files.forEach((file) => {
                        if(onlyCheckDocumentTypes){
                            if (file.validUntil == null) validFiles[file.documentType] = file;
                            else {
                                let validDate = this.$helpers.getMomentFromStringUTC(file.validUntil);
                                if (validDate < now || validDate < soonDate) filesToValid.push(file);
                                else validFiles[file.documentType] = file;
                            }
                        } else if(file.validUntil != null){
                            let validDate = this.$helpers.getMomentFromStringUTC(file.validUntil);
                            if (validDate < now || validDate < soonDate) filesToValid.push(file);
                        }
                        

                        if(file.confirmed) confirmedFiles[file.documentType] = file;
                        else filesToConfirm.push(file);
                    });

                    filesToValid.filter(file => file.documentType === 'MISC' || !validFiles[file.documentType]).forEach(file => {
                            let validDate = this.$helpers.getMomentFromStringUTC(file.validUntil);
                            if (validDate < now) expired.push(file);
                            else if (validDate < soonDate) expiringSoon.push(file);
                    })
                    filesToConfirm.filter(file => file.documentType === 'MISC' || !confirmedFiles[file.documentType]).forEach(file => unconfirmed.push(file));
                })

                let hasWarnings = (expired.length + expiringSoon.length) > 0;
                expired = expired.sort((a, b) => {
                    let aDate = view.$helpers.getMomentFromStringTZ(a.validUntil);
                    let bDate = view.$helpers.getMomentFromStringTZ(b.validUntil);
                    return aDate.unix() - bDate.unix();
                })

                expiringSoon = expiringSoon.sort((a, b) => {
                    let aDate = view.$helpers.getMomentFromStringTZ(a.validUntil);
                    let bDate = view.$helpers.getMomentFromStringTZ(b.validUntil);
                    return aDate.unix() - bDate.unix();
                })
                unconfirmed = unconfirmed.sort((a, b) => {
                    let aDate = view.$helpers.getMomentFromStringTZ(a.creationDate);
                    let bDate = view.$helpers.getMomentFromStringTZ(b.creationDate);
                    return aDate.unix() - bDate.unix();
                })
                this.expiredDocuments = expired;
                this.expiringSoonDocuments = expiringSoon;
                this.unconfirmedDocuments = unconfirmed;
            },
            checkMissingDataForUnderagedEmployees(){
                let config = this.notificationBellConfigState;
                let now = this.$helpers.getMoment();

                let underagedEmployess = Object.values(this.activeEmployeesMap).filter(e => {
                    var dobMoment = this.$helpers.getMomentFromStringTZ(e.dob);
                    var dob18yearsMoment = dobMoment.add(18, 'years');
                    return now < dob18yearsMoment;
                });
                this.missingDataForUnderagedEmployees = underagedEmployess.filter(e => {
                    return e.guardianAddress == null || e.guardianAddress === ""
                        || e.guardianName == null || e.guardianName === ""
                        || e.guardianPhone == null || e.guardianPhone === "";
                });
            },
            checkMissingAvailabilitesForParttimeEmployees(){
                let view = this;
                view.missingAvailabilityEmployees = [];

                // (re)set status of employees
                Object.values(view.activeEmployeesMap).forEach(emp => {
                    emp.hasPartTimeContract = false;
                    emp.hasAvailability = false;
                });

                // check for active or future partTime contracts
                Object.values(view.employeeContractMap).forEach(contract => {
                    let toMoment = view.$helpers.getMomentFromStringTZ(contract.to);

                    // skip old contracts
                    if (contract.to != null && toMoment <= view.$helpers.getMomentTZ()) {
                        return;
                    }
                    // skip non partTime contracts
                    if (contract.contractType !== 2) {
                        return;
                    }
                    // skip part-time contracts with no special part-time type
                    if (contract.partTimeType == null) {
                        return;
                    }

                    if (view.activeEmployeesMap[contract.employeeId] !== undefined) {
                        view.activeEmployeesMap[contract.employeeId].hasPartTimeContract = true;
                    }
                });

                // check for set availabilities
                Object.values(view.employeeAvailabilityMap).forEach(availability => {
                    if (view.activeEmployeesMap[availability.employeeId] !== undefined) {
                        view.activeEmployeesMap[availability.employeeId].hasAvailability = true;
                    }
                });

                // check for applicable employees
                Object.values(view.activeEmployeesMap).forEach(emp => {
                    if (emp.hasPartTimeContract && !emp.hasAvailability) {
                        view.missingAvailabilityEmployees.push(emp);
                    }
                });
            },
            showNotificationsPopup($event){
                let view = this;
                let labels = [];
                let config = this.notificationBellConfigState;
                if(this.eventNumber > 0){
                    labels.push({
                        classes: "notification-header",
                        type: "groupheader",
                        disabled: false,
                        show: true,
                        title: this.$tc('global.general.notification', 0),
                    });
                }
                let allHidden = Object.values(config).filter(val => val == true).length == 0;
                if(allHidden){
                    labels.push({
                        classes: "all-hidden",
                        type: "block text",
                        disabled: true,
                        show: true,
                        title: this.$t('global.menubar.messages.notificationsHidden'),
                    });
                }
                if(config.showMissingPersonnelIds && this.missingPersonnelIds.length > 0){
                    labels.push({
                        classes: "missing-contract-docs",
                        type: "block",
                        disabled: false,
                        icon: "fa-user",
                        click: ($event) => {
                            this.missingDocModalTitle = this.$t('menu.missing.personnelId');
                            this.missingDocModalDescription = this.$t('menu.missing.personnelIdDesc');
                            this.missingDocumentModalEmployees = this.missingPersonnelIds;
                            this.missingDocEmployees = true;
                        },
                        show: true,
                        title: this.missingPersonnelIds.length + " " + this.$t('menu.missing.personnelId'),
                    });
                }
                if(config.showExpiredDocuments && this.expiredDocuments.length > 0){
                    labels.push({
                        classes: "expired-docs",
                        type: "block",
                        disabled: false,
                        icon: "fa-exclamation-triangle",
                        click: ($event) => {
                            this.modalDocwarnings = true;
                        },
                        show:  true,
                        title: this.$tc('global.menubar.messages.expiredDocuments', this.expiredDocuments.length),
                    });
                }
                if(config.showExpiringDocuments && this.expiringSoonDocuments.length > 0){
                    labels.push({
                        classes: "expiring-docs",
                        type: "block",
                        disabled: false,
                        icon: "fa-exclamation-circle",
                        click: ($event) => {
                            this.modalDocwarnings = true;
                        },
                        show:  true,
                        title: this.$tc('global.menubar.messages.expiringDocuments', this.expiringSoonDocuments.length),
                    });
                }
                if(config.showUnconfirmedDocuments && this.unconfirmedDocuments.length > 0){
                    labels.push({
                        classes: "expiring-docs",
                        type: "block",
                        disabled: false,
                        icon: "fa-file-check",
                        click: ($event) => {
                            this.modalDocwarnings = true;
                        },
                        show:  true,
                        title: this.$tc('global.menubar.messages.unconfirmedDocuments', this.unconfirmedDocuments.length),
                    });
                }
                if(config.showMissingContractDocuments && this.missingContractDocuments.length > 0){
                    labels.push({
                        classes: "missing-contract-docs",
                        type: "block",
                        disabled: false,
                        icon: "fa-file-excel",
                        click: ($event) => {
                            this.missingDocModalTitle = this.$t('menu.missing.contractDocument');
                            this.missingDocModalDescription = this.$t('menu.missing.contractDocumentDesc');
                            this.missingDocumentModalEmployees = this.missingContractDocuments;
                            this.missingDocEmployees = true;
                        },
                        show: true,
                        title: this.missingContractDocuments.length + " " + this.$t('menu.missing.contractDocument'),
                    });
                }
                if(config.showExpiringContracts && this.expiringContracts.length > 0){
                    labels.push({
                        classes: "expiring-contracts",
                        type: "block",
                        disabled: false,
                        icon: "fa-calendar-times",
                        click: ($event) => {
                            this.modalExpiringContracts = true;
                        },
                        show:  true,
                        title: this.$tc('global.menubar.messages.expiringContracts', this.expiringContracts.length),
                    });
                }
                if(config.showUnapprovedPreferences && this.unapprovedPreferences.length > 0){
                    labels.push({
                        classes: "unapproved-preferences",
                        type: "block",
                        disabled: false,
                        icon: "fa-thumbs-up",
                        click: ($event) => {
                            this.modalUnapprovedPrefs = true;
                        },
                        show:  true,
                      title: this.$tc('global.menubar.messages.unapprovedPreferences', this.unapprovedPreferences.length),
                    });
                }
                if(config.showDeclinedShifts && this.declinedShifts.length > 0){
                    labels.push({
                        classes: "declined-shifts",
                        type: "block",
                        disabled: false,
                        icon: "fa-calendar-times",
                        click: ($event) => {
                            this.modalDeclinedShifts = true;
                        },
                        show:  true,
                      title: this.$tc('global.menubar.messages.declinedShifts', this.declinedShifts.length),
                    });
                }
                if(config.showMissingDataForUnderagedEmployees && this.missingDataForUnderagedEmployees.length > 0){
                    labels.push({
                        classes: "missing-underaged-data",
                        type: "block",
                        disabled: false,
                        icon: "fa-child",
                        click: ($event) => {
                            this.modalMissingDataUnderaged = true;
                        },
                        show:  true,
                        title: this.missingDataForUnderagedEmployees.length + " " +
                            this.$tc('menu.missing.dataForUnderage', this.missingDataForUnderagedEmployees.length),
                    });
                }
                if(config.showMissingAvailabilityEmployees && this.missingAvailabilityEmployees.length > 0){
                    labels.push({
                        classes: "missing-parttime-availability-employees",
                        type: "block",
                        disabled: false,
                        icon: "fa-business-time",
                        click: ($event) => {
                            this.modalMissingParttimeAvailabilityEmployees = true;
                        },
                        show:  true,
                        title: this.$tc('global.menubar.messages.missingAvailabilities', this.missingAvailabilityEmployees.length),
                    });
                }
                if(config.showMissingPassDocumentsForNonEU && this.missingPassDocs.length > 0){
                    labels.push({
                        classes: "missing-contract-docs",
                        type: "block",
                        disabled: false,
                        icon: "fa-file-excel",
                        click: ($event) => {
                            this.missingDocModalTitle = this.$t('menu.missing.thirdCountryId');
                            this.missingDocModalDescription = this.$t('menu.missing.thirdCountryIdDesc');
                            this.missingDocumentModalEmployees = this.missingPassDocs;
                            this.missingDocEmployees = true;
                        },
                        show: true,
                        title: this.missingPassDocs.length + " " + this.$t('menu.missing.thirdCountryId'),
                    });
                }
                if(config.showMissingWorkPermitDocumentsForNonEU && this.missingWorkPermitDocs.length > 0){
                    labels.push({
                        classes: "missing-contract-docs",
                        type: "block",
                        disabled: false,
                        icon: "fa-file-excel",
                        click: ($event) => {
                            this.missingDocModalTitle = this.$t('menu.missing.thirdCountryWorkPermit');
                            this.missingDocModalDescription = this.$t('menu.missing.thirdCountryWorkPermitDesc');
                            this.missingDocumentModalEmployees = this.missingWorkPermitDocs;
                            this.missingDocEmployees = true;
                        },
                        show: true,
                        title: this.missingWorkPermitDocs.length + " " + this.$t('menu.missing.thirdCountryWorkPermit'),
                    });
                }
                if(config.showMissingResidencePermitDocumentsForNonEU && this.missingResidencePermitDocs.length > 0){
                    labels.push({
                        classes: "missing-contract-docs",
                        type: "block",
                        disabled: false,
                        icon: "fa-file-excel",
                        click: ($event) => {
                            this.missingDocModalTitle = this.$t('menu.missing.thirdCountryResidencePermit');
                            this.missingDocModalDescription = this.$t('menu.missing.thirdCountryResidencePermitDesc');
                            this.missingDocumentModalEmployees = this.missingResidencePermitDocs;
                            this.missingDocEmployees = true;
                        },
                        show: true,
                        title: this.missingResidencePermitDocs.length + " " + this.$t('menu.missing.thirdCountryResidencePermit'),
                    });
                }
                let country = this.storeSettings != null ? this.storeSettings.country : 1
                if(config.showMissingEducationPermitDocumentsForNonEU && this.missingEducationPermitDocs.length > 0  &&  country == 2){
                    labels.push({
                        classes: "missing-contract-docs",
                        type: "block",
                        disabled: false,
                        icon: "fa-file-excel",
                        click: ($event) => {
                            this.missingDocModalTitle = "Mitarbeiter aus Drittstaaten ohne Schul-/Studium-Bescheinigung"
                            this.missingDocModalDescription = "Bei folgenden Mitarbeitern aus Drittstaaten ist keine Schul-/Studium-Bescheinigung vorhanden:"
                            this.missingDocumentModalEmployees = this.missingEducationPermitDocs;
                            this.missingDocEmployees = true;
                        },
                        show: true,
                        title: this.missingEducationPermitDocs.length + " Drittstaaten Mitarbeiter ohne Schul-/Studium-Bescheinigung"
                    });
                }
                labels.push({
                    type: "border-top"
                });
                labels.push({
                    classes: "notification-settings",
                    type: "groupheader",
                    disabled: false,
                    show: true,
                    title: this.$t('global.general.settings'),
                });
                labels.push({
                    classes: "notification-settings",
                    type: "block",
                    disabled: false,
                    icon: "fa-cogs",
                    click: ($event) => {
                        this.showNotificationBellConfig();
                    },
                    show: true,
                    title: this.$t('global.menubar.messages.configureNotifications'),
                });

                this.$helpers.OpenPopup({
                    type: 'listlabel',
                    componentState: {
                        labels: labels,
                    },
                    listStyle: true,
                    noScroll: true,
                    pointerDirection: 0,
                    elRelative: $event.currentTarget,
                    pointerOffset: -15,
                });
            },
            getPrefToDate(pref){
                let to = this.$helpers.getMomentFromStringTZ(pref.to);
                if(to.hour() == 0 && to.minute() == 0 && to.second() == 0 && to.millisecond() == 0){
                    return to.add(-1,'days').format('DD.MM.YYYY')
                }
                return to.format('DD.MM.YYYY');
            },
            showNotificationBellConfig(){
                let view = this;
                let config = this.notificationBellConfigState;
                let description = this.$t('global.menubar.messages.notificationsConfigHeader');
                let dataEntries = [];


                dataEntries.push({label: this.$t('global.menubar.messages.notificationsUnconfirmedDocuments'), key: 'showUnconfirmedDocuments', hidden: false, type: 'bool', value: config.showUnconfirmedDocuments});
                dataEntries.push({label: this.$t('global.menubar.messages.notificationsExpiredDocuments'), key: 'showExpiredDocuments', hidden: false, type: 'bool', value: config.showExpiredDocuments});
                dataEntries.push({label: this.$t('global.menubar.messages.notificationsExpiringDocuments'), key: 'showExpiringDocuments', hidden: false, type: 'bool', value: config.showExpiringDocuments});
                dataEntries.push({label: this.$t('global.menubar.messages.notificationsCheckOnlyDocumentTypes'), key: 'checkOnlyDocumentTypes', hidden: false, type: 'bool', value: config.checkOnlyDocumentTypes});
                
                
                dataEntries.push({label: this.$t('global.menubar.messages.notificationsExpiringDocumentsLimit'), key: 'documentExpiryLimit',
                    hidden: false, type: 'slider', value: config.documentExpiryLimit, slider: {min: 1, max: 90,
                        value: config.documentExpiryLimit, step: 1, inputControl: true, sliderInput: (x) => { return x }}});
                dataEntries.push({label: this.$t('global.menubar.messages.notificationsUnapprovedPreferences'), key: 'showUnapprovedPreferences', hidden: false, type: 'bool', value: config.showUnapprovedPreferences});
                dataEntries.push({label: this.$t('global.menubar.messages.notificationsDeclinedShifts'), key: 'showDeclinedShifts', hidden: false, type: 'bool', value: config.showDeclinedShifts});
                dataEntries.push({label: this.$t('global.menubar.messages.notificationsExpiringContracts'), key: 'showExpiringContracts', hidden: false, type: 'bool', value: config.showExpiringContracts});
                dataEntries.push({label: this.$t('global.menubar.messages.notificationsExpiringContractsLimit'), key: 'contractExpiryLimit',
                    hidden: false, type: 'slider', value: config.contractExpiryLimit, slider: {min: 1, max: 90,
                        value: config.contractExpiryLimit, step: 1, inputControl: true, sliderInput: (x) => { return x }}});
                if(!this.hasSharepoint)dataEntries.push({label: this.$t('menu.missing.contractDocument'), key: 'showMissingContractDocuments', hidden: false, type: 'bool', value: config.showMissingContractDocuments});
                dataEntries.push({label: this.$t('global.menubar.messages.notificationsMissingPersonnelIds'), key: 'showMissingPersonnelIds', hidden: false, type: 'bool', value: config.showMissingPersonnelIds});

                dataEntries.push({label: this.$t('global.menubar.messages.notificationsMissingEmployeeIds'), key: 'showMissingExternalIds', hidden: false, type: 'bool', value: config.showMissingExternalIds});

                dataEntries.push({label: this.$t('global.menubar.messages.notificationsUnpublishedShifts'), key: 'showUnpublishedShifts', hidden: false, type: 'bool', value: config.showUnpublishedShifts});
                dataEntries.push({label: this.$t('global.menubar.messages.notificationsUnapprovedBalances'), key: 'showUnconfirmedWorkbalance', hidden: false, type: 'bool', value: config.showUnconfirmedWorkbalance});
                dataEntries.push({label: this.$tc('menu.missing.dataForUnderage', 2), key: 'showMissingDataForUnderagedEmployees', hidden: false, type: 'bool', value: config.showMissingDataForUnderagedEmployees});
                dataEntries.push({label: this.$t('global.menubar.messages.notificationsshowMissingAvailabilityEmployees'), key: 'showMissingAvailabilityEmployees', hidden: false, type: 'bool', value: config.showMissingAvailabilityEmployees});

                dataEntries.push({label: this.$t('global.menubar.messages.notificationsshowMissingPassDocumentsForNonEU'), key: 'showMissingPassDocumentsForNonEU', hidden: false, type: 'bool', value: config.showMissingPassDocumentsForNonEU});
                dataEntries.push({label: this.$t('global.menubar.messages.notificationsshowMissingWorkPermitDocumentsForNonEU'), key: 'showMissingWorkPermitDocumentsForNonEU', hidden: false, type: 'bool', value: config.showMissingWorkPermitDocumentsForNonEU});
                dataEntries.push({label: this.$t('global.menubar.messages.notificationsshowMissingResidencePermitDocumentsForNonEU'), key: 'showMissingResidencePermitDocumentsForNonEU', hidden: false, type: 'bool', value: config.showMissingResidencePermitDocumentsForNonEU});
                dataEntries.push({label: this.$t('global.menubar.messages.notificationsshowMissingEducationPermitDocumentsForNonEU'), key: 'showMissingEducationPermitDocumentsForNonEU', hidden: this.storeSettings.country != 2, type: 'bool', value: config.showMissingEducationPermitDocumentsForNonEU});




                view.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        description: description,
                        selectCallback: function (data) {
                            for(let key in data){
                                if(data[key] != config[key]){
                                    view.$store.commit('setNotificationBellConfigStateValue', {key: key, value: data[key]});

                                }
                            }
                            console.log('Notification bell settings updated');
                            console.log(view.notificationBellConfigState);
                            view.checkForUserNotifications();
                        }
                    },
                    header: this.$t('global.menubar.messages.notificationsConfigTitle'),
                    expanded: true,
                    width: "1000px",
                    centered: true
                });
            },
            logout: function () {
                localStorage.removeItem('md_token');
                localStorage.removeItem('selected_store');
                localStorage.removeItem('selected_company');

                let sub = this.getSubDomain();
                if(sub ==="staging") {
                    window.location = "https://account.meindienstplan.at/#/logout?redirect=stagingmdpl";
                } else if(sub === "development") {
                    window.location = "https://account.meindienstplan.at/#/logout?redirect=devmdpl";
                } else {
                    window.location = "https://account.meindienstplan.at/#/logout?redirect=mdpl";
                }

            },
            getSubDomain: function(){
                let full = window.location.host
                //window.location.host is subdomain.domain.com
                let parts = full.split('.')
                return parts[0]
            },
            updateMdReleaseVersion: function(){
                let mdrelease = undefined;
                let host = "";
                let view = this;
                if(window.location.href.includes("localhost")){
                    host = "http://localhost";
                }else{
                    let sub = this.getSubDomain();
                    if(sub === "staging") {
                        host = "https://development.meindienstplan.at";
                    } else if(sub === "development") {
                        host = "https://development.meindienstplan.at";
                    }else{
                        host = "https://web.meindienstplan.at";
                    }
                }
                this.axios.get(host + '/mdrelease').then((response) => {
                    mdrelease = response.data.replace(/(\r\n|\n|\r)/gm, "");
                    view.mdrelease = mdrelease;
                    let savedMdrelease = localStorage.getItem('mdrelease');
                    if(savedMdrelease != mdrelease){
                        localStorage.setItem('mdrelease', mdrelease);
                        if(savedMdrelease != null && savedMdrelease != undefined){
                            // inform user of updated release and provide link to changelog article
                            let changelogUrl = "https://www.meindienstplan.at/release-notes";
                            view.$helpers.OpenAlert({
                                header: this.$t('global.MD') + ' - UPDATE INFO',
                                description: this.$t('global.menubar.messages.updateNotesDescription', { mdrelease }),
                                disableAccept: true,
                                cancelLabel: this.$t('global.ui.close'),
                                externalLabel: this.$t('global.menubar.messages.openChangelog'),
                                externalUrl: changelogUrl,
                                enableExternal: true,
                            });
                        }
                    }
                });

                this.axios.get(host + '/mdversion').then((response) => {
                    view.mdversion = response.data.replace(/(\r\n|\n|\r)/gm, "");
                });
            },
            openAbout(){
            let view = this;
            this.$helpers.OpenPopup({
                type: 'aboutpopup',
                componentState: {
                    mdrelease: view.mdrelease,
                    mdversion: view.mdversion
                },
                centered: true,
                expanded: true,
            });
        }
        },

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .menu-bar {
        position: relative;
        display: inline-block;
        width: 100%;
        height: 55px;
        background: var(--menu-bar);
        z-index: 1000;
        padding: 5px;
    }

    .menu-bar > * {
        float: left;
    }

    .icons-main {
        border-radius: 5px;
        position: relative;
        display: inline-block;
        height: 30px;
        width: 30px;
        cursor: pointer;
    }

    .icons-main .icon {
        border-radius: 5px;
        height: 25px;
        width: 25px;
        cursor: pointer;
        margin: 10px 0px 0px 10px;
        display: inline-block;
    }

    .icons-main.fixed {
        padding: 10px;
        cursor: default;
    }

    .icons-main.fixed .icon-visibility-container {
        cursor: default;
    }

    .icons-main.fixed .icon, .icons-main.fixed .fas {
        cursor: default;
        display: none;
    }

    .icons-main.fixed .icon:first-child {
        display: inline-block;
    }


    .icons-nav, .icons-left {
        position: absolute;
        left: 60px;
        /* right: 0; */
        margin: auto;
        bottom: 15px;
        height: 25px;
        /*width: 640px;*/
        text-align: left;
    }

    .icons-nav > .button:nth-last-child(2) {
        margin: 0 23px;
    }

    .icons-nav > .button:nth-last-child(2):before {
        position: absolute;
        content: '';
        height: 25px;
        width: 1px;
        top: 0;
        bottom: 0;
        left: -15px;
        margin: auto;
        background: none;
        border-right: 1px solid var(--contrast-2);
        border-radius: 0;
        pointer-events: none;
    }

    .icons-nav > .button:nth-last-child(2):after {
        position: absolute;
        content: '';
        height: 25px;
        width: 1px;
        top: 0;
        bottom: 0;
        right: -15px;
        margin: auto;
        background: none;
        border-right: 1px solid var(--contrast-2);
        border-radius: 0;
        pointer-events: none;
    }
    .icons-left{
        left: 800px;
    }
    .icons-left .store-settings{
        margin-right: 10px !important;
        float: left;
    }
    .icons-left .dividerh{
        display:none;
    }

    .icons-selection {
        position: absolute;
        /*left: 695px;*/
        left: 583px;
        margin: auto;
        bottom: 15px;
        height: 25px;
        width: 270px;
        padding-top: 5px;
    }

    .icons-selection > * {
        float: left;
        margin-right: 5px;
    }

    .icons-selection > .label {
        margin-top: -2px;
    }

    .icons-selection > .fas {
        margin-right: 5px;
        margin-left: 1px;
        font-size: 16px;
    }

    .icons-selection .dropdown-search {
        width: 180px;
        margin-top: -6px;
        margin-left: 8px;
        position: relative;
    }

    .icon-main-mz, .icon-main-mp, .icon-main-md, .icon-main-ml {

        background: url(https://web.meindienstplan.at/md-logo.png);
        background-size: 100%;
        background-position: 50%;
        background-repeat: no-repeat;
    }

    .nightmode .icon-app-switch {
        background: url(/img/btn_app_switch_light.png);
        background-size: 100%;
        background-position: 50%;
        background-repeat: no-repeat;
    }

    .daymode .icon-app-switch {
        background: url(/img/btn_app_switch.png);
        background-size: 100%;
        background-position: 50%;
        background-repeat: no-repeat;
    }

    .icon-app-switch{
        transition: .2s;
    }

    .icon-app-switch:hover{
        filter: brightness(300%);
    }

    .login {
        position: absolute;
        font-size: 14px;
        top: 15px;
        font-weight: 600;
        right: 5px;
    }

    .login > * {
        /*color: #ffffff;*/
        float: left;
        position: relative;
        margin: 0 12px 0px 5px;
        transition: 0.2s;
        cursor: pointer;
    }

    .login > *:hover {
        color: #555555;
    }

    .login > .fa-bars {
        font-size: 20px;

        margin-top: -2px;
    }

    .calendar, .nightmode-toggle {
        font-size: 20px;
        margin: 0 10px 0!important;
    }

    .login .user-logged {
        padding-left: 30px;
        padding-top: 8px;
        position: relative;
        margin-top: -6px;
    }

    .login .user-logged:hover .label {
        color: var(--bg);
    }

    .login .user-logged .label {
        pointer-events: none;
        transition: .2s;

    }

    .login .user-logged .picture {
        position: absolute;
        left: 0;
        top: 6px;
        border-radius: 100px;
        height: 25px;
        width: 25px;
        background-position: 50% 50%;
        background-size: 100%;
        background-repeat: no-repeat;
        cursor: pointer;
        transition: .2s;
    }

    .login .user-logged:hover .picture {
        box-shadow: 0 0 0 2.5px var(--contrast-4);
    }

    .login .user-logged .label {
        font-size: 13px;
        color: var(--contrast-4);
        margin-right: -0.1px;
        letter-spacing: 0.4px;
    }

    .login .fas {
        position: relative;
        color: var(--contrast-4);
        float: left;
        position: relative;
        margin: 0 5px;
        transition: 0.2s;
        cursor: pointer;
        font-size: 20px;
        height: 25px;
        width: 25px;
        padding-top: 5px;
    }

    .login .fas:hover {
        color: var(--bg);
    }

    .login .fas .notification, .menu .notification {
        position: absolute;
        background: #f43535;
        color: #ffffff;
        height: 16px;
        width: 16px;
        font-size: 8px;
        text-align: center;
        top: -8px;
        right: -8px;
        border-radius: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .login .fas .notification.big , .menu .notification.big{
        height: 17px;
        width: 17px;
        font-size: 8px;
        text-align: center;
        top: -8px;
        right: -8px;
    }

    .login .fa-bell {
        font-size: 16px;
    }

    .login .fa-sign-out-alt {
        margin-top: 2px;
    }

    .login .icon {
        font-size: 16px;
        height: 25px;
        width: 25px;
        margin-top: 0px;
        margin-right: 4px;
    }

    .login .label {
        color: var(--contrast-4);
    }
    .login .cog-correction {
        padding-top: 3px;
        margin-right: -2px;
    }
    .login .bell-correction {
        padding-top: 5px;
    }

    .menu-bar .picture{
        transition: .2s;
        cursor: pointer;
        height: 25px;
        width: 25px;
    }
    .menu-bar .picture:hover{
        box-shadow: 0 0 0 2px var(--contrast-7);
    }

    .md-card {
        position: fixed;
        z-index: 1000000;
        width: calc(60% - 18px);
        padding-bottom: 10px;
        top: 55px;
        left: 20%;
        right: auto;
        resize: both;
        overflow: hidden;
    }

    .md-card.xl {
        width: calc(80% - 18px);
        left: 10%;
    }

    .md-card-body {
        max-height: calc(98vh - 139px);
        overflow-x: auto;
    }

    .md-card-select {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: left;
        align-items: baseline;
    }

    .md-card-select .full {
        width: 100%;
    }

    .name-field {
        text-align: left;
        width: 11em;
        padding: 5px;
    }

    .dp-bold {
        font-family: DistrictProBold,serif;
    }

    .dp-book {
        font-family: DistrictProBook,serif;
    }

    .w15 {
        width: 15%;
    }

    .w20 {
        width: 20%;
    }

    .w25 {
        width: 25%;
    }

    .w33 {
        width: 33%;
    }

    .warn {
        color: var(--col-warning);
    }
    .error {
        color: var(--col-red-text);
    }

</style>
